export default {
  nav: {
    feed: 'Feed',
    map: 'Map',
    discover: 'Vibes',
    plans: 'Plans',
    messages: 'Chat',
    profile: 'Profile',
  },
  common: {
    back: 'Back',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
    edit: 'Edit',
    delete: 'Delete',
    remove: 'Remove',
    refresh: 'Refresh',
    error: 'Error',
    loading: 'Loading...',
    loadingTonyte: 'Loading Tonyte…',
    findingYourVibe: 'Finding your vibe…',
    almostThere: 'Almost there…',
    stillGettingThingsReady: 'Still getting things ready…',
    profileLoadErrorTitle: "Couldn't load your profile",
    profileLoadErrorMessage: 'Check your connection and try again.',
    tryAgain: 'Please try again.',
    clear: 'Clear',
    enable: 'Enable',
    tapToRetry: 'Tap to retry',
    somethingWentWrong: 'Something went wrong.',
    comingSoon: 'COMING SOON',
    send: 'Send',
    ok: 'OK',
    gotIt: 'Got it',
    couldNotOpenLink: 'Could not open link.',
    done: 'Done',
    retry: 'Retry',
    later: 'Later',
    notNow: 'Not now',
    openSettings: 'Open Settings',
    continue: 'Continue',
    unknown: 'Unknown',
    unknownError: 'Unknown error.',
    user: 'user',
    sharedOnTonyte: '{name} on Tonyte',
  },
  auth: {
    signInRequired: 'Sign in required',
    signInToUseFeature: 'Sign in to use this feature.',
    emailAlreadyInUse: 'An account already exists with this email. Sign in instead.',
    invalidEmail: 'Enter a valid email address.',
    invalidCredentials: 'The email or password is incorrect.',
    weakPassword: 'Use a password with at least 6 characters.',
    methodNotEnabled: 'This sign-in method is not enabled yet.',
    networkError: 'Network error. Check your connection and try again.',
    signInFailed: 'Sign-in failed. Please try again.',
    notSignedIn: 'Not signed in.',
    googleSignInUnavailable: 'Google Sign-In is not available in this build. Rebuild the app after installing the native dependencies.',
    googleSignInCancelled: 'Google sign-in was cancelled.',
    googleMissingIdToken: 'Google sign-in did not return an ID token.',
    appleSignInUnavailable: 'Apple sign-in is not available on this device.',
    appleMissingIdentityToken: 'Apple sign-in did not return an identity token.',
    appleSignInCancelled: 'Apple sign-in was cancelled.',
  },
  verifyEmail: {
    title: 'Verify your email',
    subtitle: 'We sent a verification link to',
    instructions: 'Tap the link in that email, then come back here and tap "Check again".',
    resend: 'Resend verification email',
    resendCooldown: 'Resend available in {count}s',
    resendSuccess: 'Verification email sent.',
    resendFailure: 'Could not send the verification email. Please try again.',
    resendRateLimited: 'Please wait a moment before requesting another email.',
    checkAgain: 'Check again',
    checking: 'Checking…',
    stillNotVerified: 'Not verified yet',
    stillNotVerifiedMessage: 'We still can’t see a verified email for this account. Check your inbox (and spam folder), then try again.',
    verifiedSuccess: 'Email verified! You now have full access.',
    continueBrowsing: 'Continue browsing Events & Map',
    logout: 'Log out / switch account',
    limitedAccessBanner: 'Verify your email to unlock Vibe, Plans, chat & more.',
    limitedAccessBannerAction: 'Verify now',
    gateTitle: 'Verify your email first',
    gateMessage: 'This feature unlocks once you verify your email address.',
    gateAction: 'Verify now',
    unavailable: 'Verification link unavailable',
    expiredLink: 'This verification link has expired. Request a new one from Tonyte.',
    invalidLink: 'This verification link is invalid or has already been used.',
    networkError: 'Network error. Check your connection and try again.',
    verifyFailed: 'We could not verify this link. Please request a new one.',
    missingCode: 'This verification link is missing its verification code.',
  },
  permissions: {
    locationTitle: 'Use your location?',
    locationMessage: 'Tonyte uses your location to show nearby events and plans.',
    notificationsTitle: 'Turn on notifications?',
    notificationsMessage: 'Tonyte uses notifications for new messages, plan updates and event reminders.',
    cameraTitle: 'Use your camera?',
    cameraMessage: 'Tonyte uses your camera when you choose to take photos for your profile, events, plans, or face verification.',
    microphoneTitle: 'Use your microphone?',
    microphoneMessage: 'Tonyte needs microphone access to send voice notes.',
    locationLabel: 'location', notificationsLabel: 'notifications', cameraLabel: 'camera', microphoneLabel: 'microphone',
    disabled: 'Permission disabled', notGranted: 'Permission not granted',
    blockedBody: 'Tonyte does not have access to your {permission}. You can enable it in Settings.',
    deniedBody: 'You can continue without {permission} access. Some features may be limited.',
  },
  resetPassword: {
    title: 'Reset your password',
    subtitle: 'Choose a new password for your Tonyte account.',
    expiredLink: 'This password reset link has expired. Request a new one from Tonyte.',
    invalidLink: 'This password reset link is invalid or has already been used.',
    weakPassword: 'Use a password with at least 6 characters.',
    networkError: 'Network error. Check your connection and try again.',
    verifyFailed: 'We could not verify this password reset link. Please request a new one.',
    missingCode: 'This password reset link is missing its verification code.',
    mismatch: 'The passwords do not match.',
    verifying: 'Verifying your reset link...',
    updating: 'Updating your password...',
    success: 'Password updated successfully',
    continueToLogin: 'Continue to Login',
    unavailable: 'Reset link unavailable',
    resettingFor: 'Resetting password for {email}',
    newPassword: 'New Password',
    minimumCharacters: 'At least 6 characters',
    confirmPassword: 'Confirm Password',
    enterAgain: 'Enter the password again',
    updatePassword: 'Update Password',
  },
  vibesList: {
    eyebrow: 'YOUR PEOPLE',
    title: 'Vibes',
    search: 'Search your vibes',
    noMatches: 'No matching vibes',
    noMatchesSub: 'Try searching by name, username, city, or university.',
    empty: 'No vibes yet',
    emptySub: 'People you connect with through chats and vibes will appear here.',
    openDailyVibes: 'Go to Daily Vibes',
    removeTitle: 'Remove this vibe?',
    removeBody: 'They will be removed from your Vibes list, but existing chat history will remain.',
    removeFailed: 'Could not remove this vibe right now.',
    message: 'Message',
    viewProfile: 'View Profile',
    community: 'Tonyte community',
    recentlyActive: 'Recently active',
    activeMinutes: 'Active {count}m ago',
    activeHours: 'Active {count}h ago',
    activeDays: 'Active {count}d ago',
    removeAccessibility: 'Remove {name} from Vibes',
    removeSuccess: '{name} was removed from your Vibes',
  },
  partner: {
    profileSelectorTitle: 'Choose a partner profile',
    profileSelectorBody: 'This account manages more than one partner.',
    profileUnavailableTitle: 'Partner profile unavailable',
    profileLoadFailed: 'We could not check your partner access. Try again without losing your account data.',
    profileLinkMissing: 'Your partner account is active, but no partner profile is linked to it. Contact Tonyte support to restore access.',
    publicProfileUnavailableBody: "This partner profile isn't available right now.",
    publicProfileLoadFailed: "We couldn't load this profile. Check your connection and try again.",
    kicker: 'Tonyte Partner',
    tools: 'Partner Tools',
    profile: 'Partner Profile',
    profileSub: 'Manage how your business appears on Tonyte',
    createEvent: 'Create Event',
    createEventSub: 'Publish a new event',
    myEvents: 'My Events',
    myEventsSub: 'View, edit, or delete your upcoming and live events',
    analytics: 'Analytics',
    analyticsSub: 'Total taps, interested taps, and shares',
    notifications: 'Notifications',
    notificationsSub: 'Milestones and updates about your events',
    noNotifications: 'No notifications yet.',
    totalTaps: 'Total taps',
    interestedTaps: 'Interested taps',
    shares: 'Shares',
    byEvent: 'By event',
    noAnalytics: 'No events yet — publish your first event to see analytics here.',
    untitledEvent: 'Untitled event',
    taps: 'taps',
    interested: 'interested',
    sharesLower: 'shares',
    createPassword: 'Create your password',
    firstSignIn: 'This is your first sign-in — set a new password to continue.',
    setPasswordContinue: 'Set Password & Continue',
    setPasswordFailed: 'Could not set your password. Please try again.',
    signOut: 'Sign out',
    notAssigned: 'Not assigned yet',
    categoryMissing: "Your partner category hasn't been assigned yet. Contact Tonyte Admin to have your account category set up.",
    typeCommunity: 'Community', typeOrganizer: 'Organizer', typeVenue: 'Venue', typeUniversity: 'University', typeStudentOrganization: 'Student Organization',
    businessName: 'Business name', description: 'Description', descriptionPlaceholder: "Tell people what you're about",
    website: 'Website', instagram: 'Instagram', venueAddress: 'Venue address', venueAddressPlaceholder: 'Street, city, country',
    saveChanges: 'Save Changes', viewTerms: 'View Partner Terms', requiredFields: 'Business name and description are required.',
    venueAddressRequired: 'A venue address is required.', profileUpdated: 'Profile updated.', profileSaveFailed: 'Could not save your profile. Please try again.',
  },
  editProfile: {
    nameRequired: 'Name required', addName: 'Add a name before saving your profile.',
    invalidDob: 'Invalid date of birth', ageRequirement: 'Tonyte is for travelers aged {age} and above. Please check your date of birth.',
    saveFailed: 'Could not save profile', name: 'Name *', yourName: 'Your name', bio: 'Bio',
    bioPlaceholder: 'Tell the community about yourself…', city: 'City', yourCity: 'Your city',
    country: 'Country', yourCountry: 'Your country', dateOfBirth: 'Date of Birth',
    personality: 'Personality', selectedCount: '{count}/30 selected', addCustom: 'Add "{interest}"',
  },
  onboarding: {
    languageTitle: 'Choose your language', languageSub: 'Tonyte will speak your language from here on. You can change this anytime in Settings.',
    travelerProfile: 'Your traveler profile', displayNameTitle: 'What should travelers call you?',
    displayNameSub: 'Pick a name that feels like you.', displayNameLabel: 'DISPLAY NAME', displayNamePlaceholder: 'Your display name',
    changeLater: 'You can change this later.', continue: 'Continue', photoTitle: 'Add a face to your profile',
    photoSub: 'A profile picture helps others recognize who they’re meeting.', tapUpload: 'Tap to upload', addPhoto: 'Add profile picture',
    skipNow: 'Skip for now', dobTitle: "What's your date of birth?", dobSub: 'This helps Tonyte keep plans and discovery age-appropriate.',
    dobLabel: 'DATE OF BIRTH', invalidDob: 'Please choose a valid date of birth.', dobReady: 'Date of birth added — Continue is now available.', continueLocked: 'Continue · DOB required', interests: 'Interests', selected20: '{count}/20 selected',
    unlockStudiZone: 'Unlock StudiZone', unlockStudiZoneSub: 'Verify your student status to access student-only events, Erasmus plans, campus communities and private student chats.',
    campusEvents: 'Campus events', erasmusPlans: 'Erasmus plans', studentChats: 'Student chats', verifiedGuestlist: 'Verified guestlist',
    universityEmail: 'UNIVERSITY EMAIL', universityEmailPlaceholder: 'your@university.edu', universityEmailHelp: 'Enter your university email for admin review. No spam, ever.',
    submitVerification: 'Submit for Verification', skipVerification: 'Skip for now — verify later from Profile',
    guidelinesTitle: 'Community Guidelines', guidelinesSub: 'Tonyte is built on trust and respect. Read and agree before joining.',
    guidelineRespect: 'Treat every traveler with respect — online and in person.', guidelineHarassment: 'Zero tolerance for harassment, hate speech, or abuse.',
    guidelineRealEvents: 'Only post real, accurate events and plans.', guidelineSafety: 'Prioritize safety in all meetup arrangements.',
    guidelineData: 'Your data is protected. We do not sell your information.', guidelineReport: 'Report harmful content using the in-app flag button.',
    viewTerms: 'View Terms of Service', viewPrivacy: 'View Privacy Policy', agreeTerms: 'I agree to the Terms of Service and Community Guidelines',
    enterTonyte: 'Enter Tonyte →', skipPhotoTitle: 'Skip profile picture?',
    skipPhotoBody: 'Without a profile picture, you may not be able to access all features such as Discover, joining plans, or creating plans.',
    uploadPicture: 'Upload picture', skipAnyway: 'Skip anyway', displayNameMin: 'Display name must be at least 2 characters.',
    displayNameSaveFailed: 'Could not save display name.', choosePhoto: 'Choose a profile picture or skip for now.',
    photoSaveFailed: 'Could not save profile picture.', photoSkipFailed: 'Could not skip profile picture.', dobRequired: 'Enter your date of birth to continue.',
    ageRequirement: 'Tonyte is for travelers aged {age} and above. Please check your date of birth.', profileSaveFailed: 'Could not save profile.',
    verificationSendFailed: 'Could not send verification email. Check the address and try again.', skipFailed: 'Could not skip.',
    acceptTerms: 'Please accept the Terms & Community Guidelines to continue.', setupFailed: 'Could not complete setup.',
    themeKicker: 'MAKE TONYTE YOURS', themeTitle: 'Choose your look',
    themeSubtitle: 'Pick the side of Tonyte that feels like you.', themeDaylight: 'DAYLIGHT',
    themeDaylightDescriptor: 'Bright · Warm · Social', themeMidnight: 'MIDNIGHT',
    themeMidnightDescriptor: 'Dark · Bold · Electric', themeSwitchAnytime: 'You can switch anytime from your Profile.',
    themeNotPermanent: 'Not permanent — switch anytime from your Profile.', themeEnter: 'Enter Tonyte',
    selectThemeRequired: 'Choose Daylight or Midnight to enter Tonyte.',
  },
  library: {
    myPosts: 'My Posts', profileEyebrow: 'PROFILE', events: 'events', plans: 'plans', search: 'Search by title, venue, city, tags…',
    loadingPosts: 'Loading posts…', edit: 'Edit', repost: 'Repost', planEditing: 'Plan editing',
    planEditingUnavailable: 'Plan editing is not available yet.', permissionRequired: 'Permission required',
    deletePermission: 'Only the event organizer or admins can delete this post.', deletePost: 'Delete Post', deletePostFailed: 'Could not delete post. Try again.',
    organizerLibrary: 'ORGANIZER LIBRARY', savedTemplates: 'Saved Templates', loadingTemplates: 'Loading templates…',
    eventTemplate: 'EVENT TEMPLATE', useTemplate: 'Use Template', deleteTemplate: 'Delete Template', deleteTemplateFailed: 'Could not delete template. Try again.',
    deleteConfirm: 'Delete "{title}"? This cannot be undone.', noMatches: 'No matches', noPosts: 'No posts yet',
    searchAgain: 'Try a different search term.', noPostsSub: 'Create an event or community plan to get started.',
    communityPlan: 'COMMUNITY PLAN', officialEvent: 'OFFICIAL EVENT', noTemplates: 'No saved templates',
    noTemplatesSub: 'Create an event and save it as a template for quick reuse.', untitled: 'Untitled', noVenue: 'No venue',
  },
  planRequests: {
    empty: 'No pending requests', emptySub: 'Join requests from your community plans will appear here.',
    new: 'NEW', noMessage: 'No message', decline: 'Decline', accept: 'Accept',
    acceptFailed: 'Could not accept request. Please try again.', declineFailed: 'Could not decline request. Please try again.',
    studiZoneAdmin: 'STUDIZONE ADMIN', planAdmin: 'PLAN ADMIN', studiZoneRequests: 'StudiZone Requests', joinRequests: 'Join Requests',
    traveler: 'Traveler', communityPlan: 'Community Plan',
    viewProfile: 'View profile', profileUnavailable: 'Profile unavailable', profileUnavailableBody: "This person's profile could not be found.",
  },
  publicProfile: {
    reportFailed: 'Could not submit report', blockTitle: 'Block user?', blockFailed: 'Could not block user',
    profileUnavailableTitle: 'Profile unavailable', profileUnavailableBody: "This profile doesn't exist anymore or isn't available right now.",
    vibeScore: 'VIBE SCORE', match: '% match', unvibe: 'Unvibe', report: 'Report', about: 'About',
    publicPlans: 'Public Plans', publicEvents: 'Public Events', safetyHint: 'Report and block actions are available from your direct chat menu.',
    safety: 'SAFETY', optionalDetails: 'Optional details...', unvibeWith: 'Unvibe with {name}?',
    unvibeBody: 'This removes your connection and direct chat.', keepVibe: 'Keep Vibe',
    community: 'Tonyte community', reportSubmitted: 'Report submitted', blockMessage: 'You will no longer see messages from {name}. Blocking is one-way and will not notify them.',
    userBlocked: 'User blocked', vibeSent: 'Vibe sent to {name}', vibeSendFailed: 'Could not send vibe', noLongerVibing: 'You and {name} are no longer vibing',
    unvibeFailed: 'Could not unvibe right now', message: 'Message', vibeSentStatus: 'Vibe Sent', sendVibe: 'Send Vibe',
    blocking: 'Blocking...', block: 'Block', reportPerson: 'Report {name}', sending: 'Sending...', submitReport: 'Submit Report', removing: 'Removing...',
    reasonSpam: 'Spam', reasonHarassment: 'Harassment', reasonFake: 'Fake profile', reasonContent: 'Inappropriate content',
    reasonScam: 'Scam or unsafe behavior', reasonOther: 'Other', eventFallback: 'Event', planFallback: 'Plan',
  },
  promotionsAdmin: {
    kicker: "Admin",
    title: "Promotions",
    profileSub: "Seasonal collections on the Events feed",
    manage: "Manage",
    feedEmpty: "No live collections right now.",
    new: "New",
    newTitle: "New promotion",
    untitled: "Untitled",
    adminsOnly: "Only Tonyte admins can manage promotions.",
    notFound: "This promotion no longer exists.",
    filterAll: "All",
    statusDraft: "Draft",
    statusScheduled: "Scheduled",
    statusActive: "Active",
    statusEnded: "Ended",
    statusDisabled: "Unpublished",
    statusArchived: "Archived",
    unpublishedChanges: "Unpublished changes",
    allCities: "All cities",
    emptyTitle: "No promotions yet",
    emptySub: "Create a collection like “Christmas market season” and pick the events it should highlight.",
    emptyFilter: "No promotions match this filter.",
    preview: "Preview (as it appears in the feed)",
    cover: "Cover image",
    chooseImage: "Choose image",
    replaceImage: "Replace image",
    removeImage: "Remove",
    coverHint: "Optional for now — without one the card shows a gradient. Wide photos (about 16:9) work best; it’s cropped to fill the card.",
    imageTooLarge: "The image must be smaller than 10 MB.",
    imageType: "Use a JPEG, PNG or WebP image.",
    uploadFailed: "Upload failed.",
    content: "Content",
    titleLabel: "Title",
    titlePlaceholder: "e.g. Christmas market season",
    subtitleLabel: "Subtitle",
    descriptionLabel: "Description",
    ctaLabel: "Button label",
    priorityLabel: "Priority",
    priorityHint: "Lower numbers show first when promotions overlap.",
    schedule: "Schedule",
    starts: "Starts",
    ends: "Ends",
    scheduleHint: "Berlin time. Shown from the start until the end, while at least one of its events is still upcoming.",
    cities: "Cities",
    events: "Events",
    wontShow: "Won’t show",
    endsEarly: "Ends before the promotion",
    endedAutoRemoved: "Ended — removed automatically",
    addAll: "Add all {count} matches",
    moveUp: "Move up",
    moveDown: "Move down",
    remove: "Remove",
    noEvents: "No events selected yet.",
    searchEvents: "Search upcoming events to add",
    noMatches: "No matching upcoming events.",
    checks: "Before publishing",
    ready: "Ready to publish.",
    saveDraft: "Save draft",
    publish: "Publish",
    publishChanges: "Publish changes",
    publishNow: "Publish now",
    unpublish: "Unpublish now",
    archive: "Archive",
    restore: "Restore",
    delete: "Delete",
    saved: "Draft saved.",
    savedLive: "Draft saved. Publish to update the live version.",
    fixFirst: "Fix the items under “Before publishing” first.",
    confirmPublish: "Publish now? It appears in the app immediately.",
    confirmSchedule: "Schedule this promotion to go live on {date} (Berlin)?",
    published: "Published — open apps update within seconds.",
    scheduled: "Scheduled. Goes live {date} (Berlin).",
    confirmUnpublish: "It disappears from the app immediately. Your draft is kept.",
    unpublished: "Unpublished — no longer visible in the app.",
    confirmArchive: "If it’s live it will be unpublished.",
    archived: "Archived.",
    restored: "Restored to drafts.",
    confirmDelete: "Delete “{title}” permanently? The live version and its cover image are removed. This can’t be undone.",
    discardTitle: "Discard changes?",
    discardBody: "Your unsaved changes will be lost.",
    discard: "Discard",
    scheduleNote: "It will go live automatically on {date} (Berlin).",
    publishNote: "Publishing makes it visible in the app immediately.",
    liveVersion: "Live version {version}, published {date}.",
  },
  nudges: {
    "notNow": "Not now",
    "photo": {
      "cta": "Add a photo",
      "v0": {
        "title": "Mystery guest energy 👀",
        "body": "Your profile is giving mystery guest energy. Add a photo so people know who’s joining the plan."
      },
      "v1": {
        "title": "Grand reveal? 📸",
        "body": "We love a grand reveal, but a profile photo might help first."
      },
      "v2": {
        "title": "Put a face to the name 🙂",
        "body": "A profile photo makes it way easier for people to say yes to your plans."
      }
    },
    "verification": {
      "cta": "Get Vibe Verified",
      "retryCta": "See my status",
      "v0": {
        "title": "Main character? Prove it. ✨",
        "body": "Your Vibe Verified badge is waiting. It shows people you’re really you — takes about a minute."
      },
      "v1": {
        "title": "Orange looks good on you 🧡",
        "body": "A little orange tick could look very good on you. Totally optional, very shiny."
      },
      "retry0": {
        "title": "Let’s give it another go 📸",
        "body": "Your last Vibe Verified check didn’t go through. Good light and a clear selfie usually do the trick — your status page has the details."
      }
    },
    "survey": {
      "cta": "Give feedback",
      "later": "Remind me later",
      "never": "Don’t ask again",
      "v0": {
        "title": "One week in 🎉",
        "body": "You’ve been hanging out with Tonyte for a week. Be honest — what’s good, what’s weird, what needs fixing? 👀"
      },
      "v1": {
        "title": "Got two minutes? ⏱️",
        "body": "Five quick questions, zero wrong answers. Tell us what’s working and what isn’t."
      }
    }
  },
  feedbackSurvey: {
    "kicker": "Tonyte feedback",
    "progress": "Question {step} of {total}",
    "back": "Back",
    "next": "Next",
    "skip": "Skip",
    "close": "Close",
    "otherLabel": "Other",
    "otherPlaceholder": "Tell us more (optional)",
    "version": {
      "question": "Are you using the latest version of Tonyte?",
      "hint": "We’ll double-check your installed version either way.",
      "check": "Check for updates",
      "already": "I’ve already updated",
      "checking": "Checking your version…",
      "outdatedTitle": "There’s a newer Tonyte 🚀",
      "outdatedBody": "Version {version} is out. Update first so your feedback is about the latest Tonyte — we’ll open the survey about a week after we see the update.",
      "openStore": "Open the store",
      "stillOldTitle": "Still on the older version",
      "stillOldBody": "We’re still seeing the previous build. Once the update is installed, we’ll invite you to the survey about a week later.",
      "unknownTitle": "Couldn’t check your version",
      "unknownBody": "Looks like we can’t reach Tonyte right now. Check your connection and try again — nothing is lost.",
      "retry": "Try again",
      "updatedTitle": "Thanks for updating 🧡",
      "updatedBody": "Have a look around the new version — we’ll invite you to the survey in about a week."
    },
    "q": {
      "primaryUse": {
        "title": "What do you use Tonyte for most?",
        "finding_events": "Finding events",
        "making_plans": "Making plans",
        "meeting_people": "Meeting people",
        "browsing": "Browsing what’s happening"
      },
      "foundSomething": {
        "title": "How often have you found something you wanted to do through Tonyte?",
        "often": "Often",
        "sometimes": "Sometimes",
        "once": "Once",
        "not_yet": "Not yet"
      },
      "hardestPart": {
        "title": "What has been the hardest part of using Tonyte?",
        "finding_events": "Finding relevant events",
        "finding_people_plans": "Finding people or plans",
        "understanding": "Understanding how something works",
        "bugs_slow": "Bugs or slow loading",
        "nothing": "Nothing so far"
      },
      "moreUseful": {
        "title": "What would make Tonyte more useful to you?",
        "more_events": "More events",
        "more_people_plans": "More people and plans",
        "better_recommendations": "Better recommendations",
        "easier_navigation": "Easier navigation",
        "better_performance": "Better performance"
      },
      "rating": {
        "title": "Overall, how would you rate your experience with Tonyte so far?",
        "star": "{count} of 5 stars",
        "commentLabel": "What’s one thing we should improve or keep?",
        "commentPlaceholder": "Optional"
      }
    },
    "submit": "Submit feedback",
    "submitting": "Sending…",
    "ratingRequired": "Pick a star rating to submit — everything else is optional.",
    "submitFailed": "Couldn’t send your feedback. Check your connection and try again.",
    "thanksTitle": "Thank you! 🧡",
    "thanksBody": "Every answer helps us shape Tonyte. We read all of it.",
    "done": "Done",
    "tooNewTitle": "Almost there",
    "tooNewBody": "The feedback survey opens after your first week with Tonyte. Explore a bit more and come back!",
    "waitTitle": "See you soon",
    "waitBody": "Thanks for updating! The survey opens on {date}, once you’ve had time with the new version.",
    "submittedTitle": "You already shared feedback",
    "submittedBody": "Thanks again — we’ve got your answers for this survey.",
    "inactiveBody": "There’s no survey running right now."
  },
  optionalSettings: {
    "feedbackSection": "Feedback",
    "giveFeedback": "Give feedback",
    "giveFeedbackSub": "Five quick questions — tell us what’s good and what isn’t",
    "rateTonyte": "Rate Tonyte",
    "rateTonyteSub": "Leave a review in the {store}",
    "appStore": "App Store",
    "playStore": "Play Store",
    "versionLabel": "Version {version}",
    "webVersion": "Web",
    "profileReminderNotifications": "Profile reminders",
    "reviewReminderNotifications": "Review reminders",
    "feedbackReminderNotifications": "Feedback reminders"
  },
  optionalNotifications: {
    "profileReminderTitle": "Your Tonyte profile",
    "profileReminderBody": "A quick profile touch-up is waiting for you.",
    "reviewReminderTitle": "Tonyte 🧡",
    "reviewReminderBody": "Got a minute to review Tonyte in the store?"
  },
  partnerQr: {
    "scan": "Scan to see our events on Tonyte",
    "shareImage": "Share QR code",
    "shareLink": "Share link",
    "hint": "Post the QR code to Instagram, WhatsApp or print it — scanning it opens this profile in Tonyte.",
    "hintWeb": "Take a screenshot of the QR code to post it anywhere — scanning it opens this profile in Tonyte."
  },
  partnerCalendar: {
    "by": "By {name}",
    "interestedCount": "{count} interested",
    "kicker": "Partner",
    "title": "My calendar",
    "manage": "Manage my calendar",
    "entrySub": "Drafts, scheduled, repeating and cancelled events in one place",
    "intro": "Your Tonyte calendar: plan drafts, schedule publishing, repeat events weekly and cancel single dates. Only published events are visible to the public.",
    "new": "New",
    "untitled": "Untitled event",
    "noLocation": "No location yet",
    "repeats": "Repeats",
    "missingCount": "{count} missing",
    "today": "Today",
    "events": "events",
    "lumaConnected": "Luma calendar connected — new Luma events arrive here as drafts for review.",
    "paused": "paused",
    "lumaSkipped": "{count} Luma event(s) look like events you already created here, so they were not imported twice. Review them in the partner portal.",
    "all": "All",
    "needsDetails": "Needs details",
    "prevMonth": "Previous month",
    "nextMonth": "Next month",
    "addOnDay": "Add event",
    "nothingThisDay": "Nothing on this day yet.",
    "upcoming": "Upcoming",
    "past": "Past",
    "noEvents": "No events here yet.",
    "portalHint": "Changing a repeat pattern or connecting Luma? Open the partner portal at tonyte.app.",
    "view": {
      "month": "Month",
      "list": "List"
    },
    "status": {
      "draft": "Draft",
      "scheduled": "Scheduled",
      "published": "Published",
      "cancelled": "Cancelled",
      "past": "Past"
    },
    "source": {
      "tonyte": "Tonyte",
      "luma": "Synced from Luma",
      "luma-detached": "From Luma · edited in Tonyte",
      "import": "Imported"
    },
    "seriesInfo": "{count} dates until {until}",
    "when": "When",
    "where": "Where",
    "entry": "Entry",
    "free": "Free",
    "paid": "Paid",
    "notConfirmed": "Not confirmed yet",
    "editedSeparately": "this date was edited separately",
    "goesLive": "Goes live",
    "scheduleFailed": "Scheduled publishing failed",
    "legacyRecurring": "This older repeating event is a single date. Create a new repeating event to get one entry per date.",
    "beforePublishing": "Add before publishing",
    "scopeLegend": "Apply changes to",
    "scope": {
      "one": "This date only",
      "future": "This and all following dates"
    },
    "publishAt": "Publish at (Berlin time)",
    "pickTime": "Pick a date and time to publish.",
    "saveDraft": "Save draft",
    "editingOne": "You're editing this date only. The other dates of the series stay as they are.",
    "editingFuture": "You're editing this and all following dates (dates that were edited separately stay as they are). Change the repeat pattern in the partner portal.",
    "action": {
      "edit": "Edit",
      "duplicate": "Duplicate",
      "publish": "Publish",
      "schedule": "Schedule",
      "unpublish": "Unpublish",
      "cancel": "Cancel event",
      "restore": "Restore",
      "detach": "Edit in Tonyte only",
      "delete": "Delete"
    },
    "confirm": {
      "publish": "Publish this event? It becomes visible to everyone on Tonyte.",
      "publishFuture": "Publish this and all following draft dates of the series?",
      "unpublish": "Move this event back to drafts? It disappears from the feed, map and your public profile.",
      "cancel": "Cancel this event? It stays in your calendar marked as cancelled and disappears from public views. You can restore it later.",
      "cancelFuture": "Cancel this and all following dates of the series?",
      "detach": "Stop syncing this event from Luma? Your edits in Tonyte will no longer be overwritten by Luma.",
      "delete": "Delete “{title}” permanently? This can't be undone.",
      "deleteSeriesDate": "Only this date of the series is deleted."
    },
    "luma": {
      "synced": "This event is synced from your Luma calendar.",
      "detached": "Imported from Luma, now edited in Tonyte only — Luma changes no longer apply.",
      "cancel": "Cancelling here keeps it cancelled on Tonyte, even if it's still listed on Luma.",
      "delete": "Deleting here removes it from Tonyte; Luma won't bring it back.",
      "detach": "Use “Edit in Tonyte only” to stop Luma from updating it."
    },
    "done": {
      "duplicated": "Duplicated as a draft.",
      "published": "Published.",
      "publishedMany": "{count} dates published.",
      "unpublished": "Moved back to drafts.",
      "cancelled": "Event cancelled.",
      "cancelledMany": "{count} dates cancelled.",
      "restored": "Restored as a draft.",
      "detached": "Now edited in Tonyte only.",
      "deleted": "Event deleted.",
      "scheduled": "Scheduled to publish on {date}."
    },
    "note": {
      "published": "Published events show in the feed, map and on your public profile.",
      "draft": "Drafts and scheduled events are private — only you and Tonyte admins can see them.",
      "cancelled": "Cancelled events stay visible to you only, marked as cancelled."
    }
  },
  promotions: {
    sectionTitle: "Collections",
    explore: "Explore events",
    eventsCount: "{count} events",
    collection: "Collection",
    runs: "Runs {range}",
    dateRangeNote: "Events across these dates — not only the day selected in your feed.",
    unavailableTitle: "This collection isn’t available",
    unavailableSub: "It may have ended or been removed. Check the Events feed for what’s on now.",
    backToEvents: "Back to events",
  },
  studiZone: {
    locked: 'StudiZone Locked', lockedSub: 'Verify your student status to unlock student events, Erasmus meetups, campus plans and university nightlife.',
    verifyStatus: 'Verify Student Status', underConstruction: 'under construction', constructionSub: "We're putting the finishing touches on StudiZone. Your verified status is saved — you'll have full access when it launches.",
    verifiedLayer: 'Verified student layer', exit: 'Exit', loading: 'Loading StudiZone...', createPlan: 'Create Student Plan',
    planChat: 'StudiZone plan chat · {count} members', unlockedSub: 'Student-only plans, chats and campus nightlife are unlocked for this profile.',
    planRequests: 'Plan requests', soon: 'Soon', campusMap: 'Campus map', studentPins: '{count} student pins', openMap: 'Open full map',
    emptyLane: 'Nothing in this lane yet', emptyLaneSub: 'StudiZone is ready for student-only drops, societies, campus events and Erasmus plans.',
    loadingMap: 'Loading student map...', mapTitle: 'Campus Map', pins: 'StudiZone pins',
    tonyteStudent: 'Tonyte Student', studentDiscounts: 'Student discounts', universityCommunities: 'University communities',
    societiesClubs: 'Societies & clubs', campusHeatmaps: 'Campus heatmaps',
    categoryAll: 'All', categoryCampus: 'Campus', categoryParties: 'Parties', categoryErasmus: 'Erasmus', categoryWorkshops: 'Workshops', categorySports: 'Sports', categoryFree: 'Free',
    tabFeed: 'Feed', tabPlans: 'Plans', tabChats: 'Chats', tabProfile: 'Profile',
    hey: 'Hey {name}', upcoming: 'Upcoming', eventsCount: '{count} events', today: 'Today', tomorrow: 'Tomorrow',
    free: 'Free', verified: 'Verified', timeTba: 'Time TBA', campusMapSub: "See what's happening around campus",
    searchUniversities: 'Search universities', dresden: 'Dresden', campusEventsCount: '{count} campus events', noCampusEvents: 'No events pinned on this campus yet', noCampusEventsSub: 'Events with a building on this campus show up here.', buildingFilter: 'Building {code}', noUniversityResults: 'No university found', yourUniversity: 'Your uni', campusesCount: '{count} campuses', allEvents: 'All StudiZone events',
  },
  verification: {
    signInSub: 'Please sign in to start verification.', title: 'Verification Center',
    subtitle: 'Manage trust badges and optional StudiZone access from one place.', vibe: 'Vibe Verification', retake: 'Retake',
    student: 'Student Verification', emailPlaceholder: 'name@university.edu', backToTonyte: 'Back to Tonyte',
    validStudentEmail: 'Enter a valid student email address.', emailSent: 'Verification email sent. Check your university inbox.',
    emailSendFailed: 'Could not send verification email.', selfieTooSmall: 'Selfie is too small or unclear. Retake it with good light and your face visible.',
    submitted: 'Submitted for review.', submitFailed: 'Could not submit verification.', verified: 'Verified', pending: 'Pending', failed: 'Failed', notVerified: 'Not verified',
    vibeDescription: 'A trust and safety badge that shows other people your profile belongs to a real person. Verification is automatic and instant — the Tonyte team may still review submissions afterward.',
    studentDescription: 'Optional verification for people who want access to StudiZone. It does not change the main Tonyte experience.',
    pendingReview: 'Pending Review', tryAgain: 'Try again', start: 'Start Verification', submitting: 'Submitting...', submitReview: 'Submit for Review',
    poseGuideTitle: 'Get Vibe Verified',
    poseGuideBody: "Quick face check\n\nWe'll take three photos automatically:\n• Looking straight ahead\n• Looking to your left\n• Looking to your right\n\nMake sure your face is clearly visible and you're in good lighting.\n\nYour photos are securely submitted for verification and may be reviewed by the Tonyte team.",
    poseGuideOpenCamera: 'Continue',
    camera: {
      requestingPermission: 'Requesting camera access…',
      permissionDenied: 'Camera access is needed to verify your Vibe. Enable it in Settings and try again.',
      openSettings: 'Open Settings',
      onePersonOnly: 'Only one person should be in frame',
      of: 'of',
      moveIntoFrame: 'Move your face into the frame',
      lookStraight: 'Look straight at the camera',
      turnLeft: 'Show your left profile',
      turnRight: 'Now show your right profile',
      holdStill: 'Hold still…',
      faceDetected: 'Face detected ✓',
      frontCaptured: '✓ Front captured',
      leftCaptured: '✓ Left captured',
      rightCaptured: '✓ Right captured',
      verificationComplete: "You're Vibe Verified ✓",
      uploading: 'Uploading your photos…',
      fallbackMessage: "Couldn't verify automatically. You can submit your photos for manual review instead.",
      fallbackSubmit: 'Submit for manual review',
      tryAgain: 'Try again',
      errorGeneric: "Couldn't complete verification. Make sure your face is clearly visible and try again.",
    },
  },
  verificationComplete: {
    noToken: 'No verification token found. Please use the link from your email.', couldNotComplete: 'Verification could not be completed.', expiredBody: 'This link has expired. Please request a new verification email in the app.', invalidBody: 'This verification link is invalid or has already been used.', verifying: 'Verifying…', verified: 'Student email verified', underReview: 'Under review', expired: 'Link expired', invalid: 'Invalid link', failed: 'Verification failed', checking: 'Checking your student email verification…', verifiedUniversity: 'Student email verified. Welcome to StudiZone. Your {university} student status has been confirmed.', verifiedWelcome: 'Student email verified. Welcome to StudiZone.', pendingBody: 'Email ownership confirmed. Your student verification is pending review.', back: 'Back to Tonyte',
  },
  uploadPlan: {
    signInBody: 'Sign in before creating a plan.', missingDetails: 'Missing details', missingDetailsBody: 'Add a plan title and description.',
    missingLocation: 'Missing location', missingLocationBody: 'Add the meeting location and city.', missingDate: 'Missing date', missingDateBody: 'Select the start date and time.',
    participantLimit: 'Participant limit', participantLimitBody: 'Plan participant limit must be at least 2.', safetySetup: 'Safety setup', safetySetupBody: 'Acknowledge the safety responsibility before publishing.',
    invalidDate: 'Invalid date', futureDate: 'Please select today or a future date.', invalidTime: 'Invalid time', pastTime: 'Start time cannot be in the past.', publishFailed: 'Could not publish plan',
    back: '← Back', communityPlan: 'Community Plan', createPlan: 'Create Plan', alwaysFree: 'Plans are always free', alwaysFreeBody: 'Community plans cannot enable payments or tickets.',
    title: 'Plan title', description: 'Plan description', city: 'City', cityHelp: 'Plans only show inside the selected city.', chooseCity: 'Choose your city',
    dateRange: 'Date Range', dateRangeHelp: 'Help others know when and where to meet.', location: 'Location', locationPlaceholder: 'Where should people meet?', dateFrom: 'Date from', timeFrom: 'Time from',
    safety: 'Safety Setup', safetyHelp: 'Help others understand what kind of plan they are joining.', hostedAt: 'Hosted at', hostedHelp: 'Choose whether this plan is hosted at a public place, private place, or unknown location type.',
    visibility: 'Plan Visibility', visibilityHelp: 'Choose who can discover this plan.', maxParticipants: 'Max Participants (optional)', unlimited: 'Leave empty for unlimited',
    responsibility: 'I understand that I am responsible for creating a safe and respectful plan.', publish: 'Publish Plan', publicPlace: 'Public place', privatePlace: 'Private place', unknown: 'Unknown', public: 'Public', friends: 'Friends', inviteOnly: 'Invite only',
    startedFromTemplate: 'Started from a Tonyte template',
    endsAt: 'Plan ends at',
    endsAtHelp: 'The plan disappears from Tonyte after this time and is then deleted automatically.',
    endDate: 'End date',
    endTime: 'End time',
    missingEnd: 'Missing end time',
    missingEndBody: 'Choose when the plan ends.',
    endBeforeStart: 'The plan must end after it starts.',
    endTooLate: 'A plan can last at most 14 days.',
  },
  uploadEvent: {
    signInBody: 'Sign in before publishing an event.', missingDetails: 'Missing details', missingDetailsBody: 'Add an event title and description.',
    missingDate: 'Missing date', missingDateBody: 'Select the start date and time.', participantLimit: 'Participant limit', participantLimitBody: 'Enter 0 for unlimited, or a participant limit greater than 0.',
    invalidDate: 'Invalid date', futureDate: 'Please select today or a future date.', invalidTime: 'Invalid time', startPast: 'Start time cannot be in the past.', endBeforeStart: 'End date cannot be before start date.',
    endTimeBeforeStart: 'End time must be after start time.', untilBeforeStart: 'Until date cannot be before the event start date.', tagRequired: 'Event tag required', tagRequiredBody: 'Please select at least one event tag so people can discover your event.',
    permissionRequired: 'Permission required', editPermission: 'Only admins, co-admins, and the event organizer can edit this event.', addressWarning: "We couldn't verify this exact address, but we'll save it as typed.", publishFailed: 'Could not publish event',
    back: '← Back', officialEvent: 'Official Event', editEvent: 'Edit Event', repostEvent: 'Repost Event', fromTemplate: 'New from Template', createEvent: 'Create Event', addCover: 'Add Cover Photo', invalidImage: 'Invalid event image', imageTooLarge: 'Choose an image smaller than 15 MB.', unsupportedImage: 'Choose a JPEG, PNG, WebP, HEIC, or HEIF image.',
    title: 'Event title', description: 'Event description', venueOrganizer: 'Venue / organizer', lineup: 'Lineup / hosts (comma separated)', websiteUrl: 'Website URL', instagramUrl: 'Instagram URL', sourceUrl: 'Event / source page URL',
    location: 'Location', locationHelp: 'Search for a venue or address. Select from the suggestions to pin your event on the map.', city: 'City', cityHelp: 'Events only show inside the selected city.',
    dateRange: 'Date Range', dateRangeHelp: 'Set the public event date and time window.', dateFrom: 'Date from', dateTo: 'Date to', timeFrom: 'Time from', timeTo: 'Time to', lastEntry: 'Last entry time', lastEntryHelp: 'Hide this event from Ongoing after this time, even if it ends later.',
    eventTags: 'EVENT TAGS', tagsHelp: 'Select all that apply · at least one required', maxParticipants: 'Maximum participants', maxParticipantsHelp: 'Enter 0 for unlimited participants.', maxParticipantsPlaceholder: 'Max participants',
    freeEvent: 'Free Event', freeEventHelp: 'All events are free in the current Tonyte build.', saveTemplate: 'Save as template', saveTemplateHelp: 'Store this full event post for future uploads.', saveCurrentTemplate: 'Save current fields as template',
    recurring: 'Recurring event', recurringHelp: 'Use the template fields and create multiple event instances.', oneTime: 'One-time event', weekly: 'Weekly', custom: 'Custom', repeatEvery: 'Repeat every', until: 'Until', occurrences: 'Occurrences',
    customDates: 'Custom event dates', customDatesHelp: 'Comma separated dates, e.g. 2026-06-15, 2026-06-22', skipDates: 'Skip dates', skipDatesHelp: 'Comma separated dates to skip.',
    saveEvent: 'Save Event', publishRepost: 'Publish Repost', publishEvent: 'Publish Event', selectCity: 'Select city', locationRequired: 'Location required', locationRequiredBody: 'Please search for and select a location from the suggestions so your event can appear on the map.', ok: 'OK',
    hashtags: 'Hashtags', selected: 'selected', addHashtags: 'Add hashtags', collapseHashtags: 'Collapse hashtags', hashtagsHelp: 'Search or add event hashtags. Separate multiple hashtags with commas.',
  },
  venueProfiles: {
    open: 'Open', mapUnavailable: 'Map unavailable', noAddress: 'This venue does not include an address yet.', mapOpenFailed: 'Could not open map',
    followers: 'Followers', posts: 'Posts', events: 'Events', upcoming: 'Upcoming', past: 'Past', about: 'About', calendar: 'Calendar', noEventsOnDay: 'No events on this day.', yourVenue: 'Your profile', editProfile: 'Edit profile', editLoadFailed: 'Could not load your profile', editSaveFailed: 'Could not save your changes', editNotAllowed: 'Only this venue\u2019s owner can edit its profile.', coverPhoto: 'Cover photo', profilePhoto: 'Profile picture', changePhoto: 'Change', coverHint: 'Drag to move, pinch or use the slider to zoom. It shows in exactly this shape on your profile and in Vibe at Venues.', adjustPhoto: 'Adjust', bioLabel: 'Bio', bioPlaceholder: 'Tell people what your place is about', categoryLabel: 'Category', dashboard: 'Analytics dashboard', analytics: 'Analytics', calendarImports: 'Calendar imports', unavailable: 'This profile isn\u2019t available.', calendarImportsSub: 'Review and publish your imported events', dashboardSub: 'Taps, interest, shares and event performance', follow: 'Follow', following: 'Following',
    organizerNotFound: 'Organizer not found', organizerUnavailable: 'This organizer profile is not available yet.',
    vibesTitle: 'Vibe at Venues', vibesSubtitle: 'Find the places where your people gather.', search: 'Search venues, clubs, cafés, bars...', refreshFailed: 'Could not refresh venue posts. Showing what is available.', noVenues: 'No venues found', noVenuesSub: 'Try another search or category.',
    signInFollowVenue: 'Log in before following venues.', signInFollowOrganizer: 'Log in before following organizers.', signInLike: 'Log in before liking venue posts.', signInComment: 'Log in before commenting on venue posts.', signInDeleteComment: 'Log in before deleting comments.', notAllowed: 'Not allowed', ownCommentsOnly: 'You can delete only your own comments.',
  },
  waitingList: {
    title: "You're on the waiting list",
    badge: 'EARLY ACCESS',
    headline: 'Stop scrolling.\nStart going out.',
    supportingText: "We're gradually inviting new members to keep the community authentic, active, and safe.",
    featureEventsTitle: 'Find Events',
    featureEventsBody: "Discover what's happening around you.",
    featurePlansTitle: 'Create Plans',
    featurePlansBody: 'Start a plan and find people to join.',
    featureVibeTitle: 'Daily Vibe',
    featureVibeBody: 'Answer a few questions and discover your vibe matches.',
    featureTogetherTitle: 'Never Feel Alone',
    featureTogetherBody: 'Always find something to do and someone to do it with.',
    applicationReceived: 'Application received',
    notificationText: "We'll notify you as soon as your account is activated.",
    currentCity: 'Current city',
    footer: 'Thanks for helping us build the future of social discovery.',
    visitWebsite: 'Visit Website',
    visitWebsiteSub: 'See how Tonyte works →',
  },
  login: {
    missingDetails: 'Missing details',
    enterEmailPassword: 'Enter your email and password.',
    passwordTooShort: 'Password too short',
    passwordMin: 'Use at least 6 characters.',
    emailSignInFailed: 'Email authentication failed',
    emailRequired: 'Email required',
    enterResetEmail: 'Enter your email address to reset your password.',
    forgotPassword: 'Forgot password?',
    resetEmailSent: 'Reset email sent',
    resetEmailSentMessage: 'Check your inbox for a link to reset your password.',
    passwordResetFailed: 'Password reset failed',
    signInFailed: 'Sign-in failed',
    appleSignInFailed: 'Apple Sign-in failed',
    signInWithEmail: 'Sign in with email',
    createYourAccount: 'Create your account',
    signIn: 'Sign in',
    create: 'Sign up',
    createAccount: 'Create Account',
    email: 'Email',
    password: 'Password',
    findYour: 'Find your',
    people: 'people',
    plans: 'plans',
    tagline: 'Stop scrolling.\nStart going out.',
    featurePeople: 'Find your people',
    featureEvents: "See what's on",
    featureAlone: 'Never go out alone',
    continueWithEmail: 'Continue with Email',
    continueWithGoogle: 'Continue with Google',
    continueWithApple: 'Continue with Apple',
    legalPrefix: 'By continuing you agree to our',
    and: 'and',
    partnerSignInHint: 'Tonyte Partner? Sign in above with your Partner ID or email',
  },
  settings: {
    title: 'Settings',
    account: 'Account',
    appearance: 'Appearance',
    midnight: 'Midnight',
    daylight: 'Daylight',
    language: 'Language',
    appLanguage: 'App language',
    languageSaved: 'Language saved',
    languageSaveError: 'Could not save language.',
    profileManagement: 'Profile Management',
    profileCompleted: 'Profile completed',
    profileCompletedSub: 'Your profile answers are fully set.',
    editProfile: 'Edit Profile',
    editProfileAnswers: 'Edit profile answers',
    completeProfile: 'Complete profile',
    notifications: 'Notifications',
    pushNotifications: 'Push Notifications',
    legal: 'Legal',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    communityGuidelines: 'Community Guidelines',
    impressum: 'Impressum',
    partnerTerms: 'Partner Terms',
    dataDeletionRequest: 'Data Deletion Request',
    about: 'About',
    version: 'Version {version}',
    tagline: 'Meet people. Live the night.',
    accountPrivacy: 'Account Privacy',
    blockedAccounts: 'Blocked Accounts',
    faq: 'FAQ',
    helpFeedback: 'Help & Feedback',
    verificationCenter: 'Verification Center',
    savedTemplates: 'Saved Templates',
    uploadedPlans: 'Uploaded Plans',
    adminControls: 'Admin Controls',
    dataDeletion: 'Data Deletion',
    logout: 'Logout',
    deleteAccount: 'Delete Account',
    studentVerification: 'Student Verification',
    vibeVerification: 'Get Vibe Verified',
    tonyteSettings: 'Tonyte settings',
    search: 'Search settings', clearSearch: 'Clear settings search', profile: 'Profile', partnerDashboard: 'Partner Dashboard', preferences: 'Preferences', privacyLegal: 'Privacy & Legal', support: 'Support', session: 'Session', noSettings: 'No settings found', noSettingsSub: 'Try a different keyword.',
    connectedEmail: 'Connected Email', noEmail: 'No email connected', signInMethod: 'Sign-in Method', noSignInMethod: 'No sign-in method found.', passwordLogin: 'Password login enabled', connected: '{provider} connected', sendReset: 'Send Password Reset', sending: 'Sending...', unblock: 'Unblock', noBlocked: 'No blocked accounts.', searchFaq: 'Search FAQ', feedbackPlaceholder: "Tell us what's on your mind...", feedbackEmail: 'Contact email (optional)', sendFeedback: 'Send Feedback', chatNotifications: 'Messages & Vibes', eventNotifications: 'Plans', eventRecommendationNotifications: 'Events & Recommendations', partnerNotifications: 'Partners I Follow', verifiedStudent: 'Verified Student', verifiedStudentSub: 'You have full access to student-only events. Your student email is kept private.', checkInbox: 'Check your inbox',
    verificationSentPrefix: 'We sent a verification link to', verificationSentSuffix: 'Click the link in that email to confirm ownership.', linkExpiry: "The link expires in 24 hours. Check your spam folder if you don't see it.", wrongEmail: 'Wrong email?', differentUniversityEmail: 'Enter a different university email', resendVerification: 'Resend Verification Email', pendingReview: 'Pending review', pendingReviewSub: "Your email ownership was confirmed. An admin will review your institution shortly. You'll get access once approved.", verificationFailed: 'Verification failed', studentFailedSub: 'Your verification was not approved. Please try again with a valid university email.', universityEmail: 'University / student email', universityEmailHelp: "Enter your university email. We'll send a verification link. Known institutions are approved instantly; others are reviewed within 24 hours.", sendVerification: 'Send Verification Email',
    vibeVerifiedTitle: 'Vibe Verified', vibeVerifiedSub: 'Your profile has the badge. Other users see trust, not your selfie.', privacy: 'Privacy', verificationPrivacy: 'Verification is automatic and instant. Your photos are kept privately for the Tonyte team to review afterward, and are never shown on your public profile.', verificationPending: 'Verification pending', verificationPendingSub: 'Confirming your photos — this only takes a moment.', submittingSelfie: 'Submitting your selfie…', pendingAdminSub: 'Your request will stay pending until an admin reviews it.', selfieFailedSub: 'Retake the selfie with good lighting and your face visible.', tryAgain: 'Try Again', reviewSelfie: 'Review your selfie', reviewSelfieSub: 'Make sure your face is clear before submitting.', retake: 'Retake', submitReview: 'Submit for Review', getVerified: 'Get Vibe Verified', getVerifiedSub: 'Three quick automatic photos — looking straight ahead, then left, then right — show you’re a real person and build trust with others.', examplePose: 'Example pose', matchPose: 'Take a selfie matching the pose above.', faceVisible: 'Face clearly visible', gestureVisible: 'Hand gesture visible', goodLighting: 'Good lighting', noFilters: 'No filters or screenshots', takeVerificationSelfie: 'Start verification',
    deleteAccountTitle: 'Delete Account', deleteAccountConfirm: 'Are you sure you want to permanently delete your Tonyte account? This action cannot be undone.', deleteProfileInfo: 'Your profile will no longer be visible.', deleteDataInfo: 'Your private chats, matches, blocks, swipes, and account data will be removed.', deletePlansInfo: 'Your community plans will be deleted. Public events are not deleted by this action.', confirmIdentity: 'Confirm it is you', reauthenticate: 'For security, please reauthenticate with {provider} before we delete your account.', enterPassword: 'Enter your password',
    loadingUsers: 'Loading users…', totalUsers: '{count} total users', searchUsers: 'Search users...', noEmailAvailable: 'No email available', protectedAccount: 'Protected account', revoking: 'Revoking…', revokeVerified: 'Revoke Vibe Verified', noUsers: 'No users found', suspendAccountAction: 'Suspend', unsuspendAccountAction: 'Unsuspend', suspending: 'Updating…', suspendAccountTitle: 'Suspend account', unsuspendAccountTitle: 'Unsuspend account', suspendAccountConfirm: 'Suspend {name}’s account? They will be signed out and unable to sign back in until unsuspended.', unsuspendAccountConfirm: 'Unsuspend {name}’s account? They will be able to sign in again.', suspendAccountSuccess: '{name} has been suspended.', unsuspendAccountSuccess: '{name} has been unsuspended.', suspendAccountFailed: 'Could not suspend this account. Please try again.', unsuspendAccountFailed: 'Could not unsuspend this account. Please try again.', cannotSuspendSelf: 'You cannot suspend your own account.', deleteAccountAction: 'Delete account', deletingAccount: 'Deleting…', deleteAccountTitle: 'Delete account', deleteAccountConfirm1: 'Permanently delete {name} ({email})? This will remove their account and cannot be undone.', deleteAccountFinalTitle: 'Are you absolutely sure?', deleteAccountFinalBody: 'This permanently deletes the account from Firebase Authentication and Tonyte. This action cannot be undone.', deleteAccountFinalAction: 'Permanently delete', deleteAccountSuccess: '{name} has been permanently deleted.', deleteAccountFailed: 'Could not delete this account. Please try again.', cannotDeleteSelf: 'You cannot delete your own account.', cannotDeleteAdmin: 'Admins cannot delete other admin accounts.', noPendingRequests: 'No pending requests', requestedEmail: 'Requested email', domain: 'Domain', requested: 'Requested', emailOwnership: 'Email ownership', confirmed: 'Confirmed', notConfirmed: 'Not confirmed', accept: 'Accept', noPendingFace: 'No pending face requests', noAccountEmail: 'No account email', shakaSelfie: 'Shaka selfie', posePassLabel: 'Pose', livenessPassLabel: 'Liveness', front: 'Front', left: 'Left', right: 'Right', approve: 'Approve', reject: 'Reject', autoApproved: 'Auto-approved ✓', eventCity: 'Event City', eventCityHelp: 'Changes your Feed and Map city.',
  },
  notifications: {
    newJoinRequest: 'New Join Request',
    newJoinRequestBody: 'You have a new join request.',
    planAccepted: "You're in 🎉",
    planAcceptedBody: "You've been accepted into a plan.",
    newVibeRequest: 'New Vibe request ✨',
    newVibeRequestBody: 'Someone wants to vibe with you.',
    vibeAccepted: "It's a Vibe ✨",
    vibeAcceptedBody: 'Your Vibe request was accepted.',
    eventsTitle: 'What\'s on in Dresden',
    eventsBody: 'New events are waiting for you.',
    vibePlanTitle: "A vibe of yours created a plan",
    vibePlanBody: "Tap to see the plan and join in.",
    partnerUpdateTitle: 'Update from a partner you follow',
    partnerUpdateBody: 'See what’s new.',
    newFollowerTitle: 'You’ve got a new follower 🧡',
    newFollowerBody: 'Someone just followed you on Tonyte.',
    profilePhotoReminderTitle: "Complete your Tonyte profile 👋",
    profilePhotoReminderBody: "Add a profile picture to unlock Plans and Vibes.",
    appUpdateReminderTitle: "A better Tonyte is waiting 🧡",
    appUpdateReminderBody: "Update Tonyte for the latest features, fixes and improvements.",
  },
  chat: {
    title: 'Chat',
    subtitle: 'Chats, vibe requests, and sent vibes',
    chats: 'Chats',
    vibeRequests: 'Vibe Requests',
    sentVibes: 'Sent Vibes',
    searchChats: 'Search chats',
    noMessages: 'No messages yet',
    noChatsFound: 'No chats found',
    noChatsYet: 'No chats yet',
    tryDifferentKeyword: 'Try a different name or keyword.',
    chatsAppearHere: 'Your chats will appear here',
    joinToStart: 'Join an event or send a vibe to start chatting.',
    signInToUseVibes: 'Sign in to use vibes',
    signInSub: 'Create an account to view vibe requests and private chats.',
    translateChat: 'Translate Chat',
    translatingChat: 'Translating...',
    showOriginal: 'Show Original',
    translationFailed: 'Could not translate chat.',
    chatUnmuted: 'Chat unmuted',
    chatMuted: 'Chat muted',
    leftChat: 'You left the chat',
    blockUserQuestion: 'Block user?',
    blockUserMessage: 'You will no longer see messages from {name}. Blocking is one-way and will not notify them.',
    thisUser: 'this user',
    block: 'Block',
    userBlocked: 'User blocked',
    couldNotBlockUser: 'Could not block user',
    deleteChatQuestion: 'Delete chat?',
    deleteChatMessage: 'This chat will be permanently deleted and cannot be undone.',
    chatDeleted: 'Chat deleted',
    couldNotDeleteChat: 'Could not delete chat',
    deletePlanMessage: 'This will permanently delete the plan and its chat for all participants.',
    vibePromptsReady: 'Your vibe sync prompts are ready',
    you: 'You',
    traveler: 'Tonyte member',
    tonyteEvent: 'TONYTE EVENT',
    tonyteVenue: 'TONYTE VENUE',
    openEvent: 'Open event',
    directMessage: 'Direct message',
    youBlockedUser: 'You blocked this user',
    unblockInSettings: 'Unblock them from profile settings to see this chat again.',
    vibeEnded: 'This Vibe has ended',
    vibeEndedBody: 'This connection and its chat history no longer exist. Send a new Vibe request to reconnect.',
    eventChatEnded: 'This event has ended',
    planChatEnded: 'This plan has ended',
    removeFromPlan: 'Remove from Plan',
    removeFromPlanQuestion: 'Remove {name} from this plan?',
    removeFromPlanMessage: "They'll lose access to the plan chat and will no longer be part of the plan.",
    removedFromPlan: "You've been removed from this plan.",
    memberRemoved: 'Member removed',
    couldNotRemoveMember: 'Could not remove this member. Please try again.',
    typeMessage: 'Type a message...',
    couldNotSendImage: 'Could not send image.',
    locationUnavailable: 'Location unavailable.',
    couldNotSendLocation: 'Could not send location.',
    sharedLocationLabel: 'Shared location',
    viewOnMap: 'View on map',
    invalidSharedLocation: "This location can't be opened right now.",
    eventExpiredLabel: 'EXPIRED',
    eventExpired: 'Event expired',
    eventExpiredToast: 'This event is no longer available.',
    microphoneNowEnabled: 'Microphone access enabled',
    reply: 'Reply',
    gifs: 'GIFS',
    gifSearchResults: 'Search results',
    gifTrendingNow: 'Trending now',
    searchGiphy: 'Search GIPHY',
    recentlyUsed: 'Recently used',
    gifsLoadFailed: 'GIFs could not load. Check your connection and try again.',
    microphoneAccessNeeded: 'Microphone access needed',
    microphoneAccessMessage: 'Tonyte needs microphone access to send voice notes. Enable it in Settings to continue.',
    recordingUnavailable: 'Recording unavailable',
    recordingUnavailableMessage: "Couldn't start the voice recorder. Please try again.",
    wantsToVibe: 'Wants to vibe with you', status: 'Status: {status}', accepted: 'Accepted', passed: 'Passed', pending: 'Pending',
    profileSource: 'Tonyte profile', sharedPlan: 'Shared plan', sharedEvent: 'Shared event', noRequestMessage: 'No message added yet.',
    vibe: 'Vibe', pass: 'Pass', alreadyVibing: 'Already Vibing', cancel: 'Cancel', delete: 'Delete', vibeVerified: 'Vibe Verified', bio: 'Bio', interests: 'Interests', requestMessage: 'Request message', viewProfile: 'View profile', working: 'Working...', cancelRequest: 'Cancel request',
    peopleHere: 'PEOPLE HERE', connectTravelers: 'Find your people', loadingTravelers: 'Loading people...', tryAgain: 'Try Again', noTravelers: 'No one else is here yet.', noTravelersSub: 'Be the first to open People Here and your card will appear to others.',
    vibing: 'Vibing', sent: 'Sent', accept: 'Accept', sendVibe: 'Send a vibe', sendVibeSub: 'Add a short note for {name}. You can also send it blank.', optionalMessage: 'Optional message...', sending: 'Sending...', sendVibeAction: 'Send Vibe',
    planChat: 'PLAN CHAT', eventChat: 'EVENT CHAT', communityPlan: 'Community Plan', officialEvent: 'Official Event', vibingWith: 'Vibing With', groupCount: '{count} {people} in this {kind} chat', person: 'person', people: 'people', plan: 'plan', event: 'event', loadingMembers: 'Loading members...',
    openProfiles: 'Open profiles and send vibes', deleteChat: 'Delete Chat', leaveChat: 'Leave Chat', adminCannotLeave: 'Plan admins cannot leave the chat. Delete this plan instead?', noStay: 'No, stay', yesDeletePlan: 'Yes, delete plan', leavePlanConfirm: 'Leave this plan chat? You can rejoin from the plan page.', leaveEventConfirm: 'Leave this event chat?', leaving: 'Leaving…', leave: 'Leave',
    safety: 'SAFETY', reportPerson: 'Report {name}', chooseReason: 'Choose a reason first.', reportFailed: 'Report failed. Please try again.', optionalDetails: 'Optional details…', submitReport: 'Submit Report', reportUser: 'Report User', blockUser: 'Block User', viewProfileTitle: 'View Profile', muteChat: 'Mute Chat', unmuteChat: 'Unmute Chat',
    loadingRequests: 'Loading requests...', noPendingRequests: 'No pending vibe requests', pendingRequestsSub: 'Received requests will appear here before they move to Chats.', loadingSent: 'Loading sent vibes...', noSent: 'No sent vibes yet', noSentSub: 'Vibes you send from People Here will be tracked here.',
    reasonSpam: 'Spam', reasonHarassment: 'Harassment', reasonFake: 'Fake profile', reasonContent: 'Inappropriate content', reasonScam: 'Scam or unsafe behavior', reasonOther: 'Other',
    newMessage: 'New message', newMessageFallback: 'You received a new message.',
    someone: 'Someone', requestAcceptFailed: 'Could not accept request. Please try again.', requestDeclineFailed: 'Could not decline request. Please try again.', requestCancelFailed: 'Could not cancel request. Please try again.',
    travelersLoadFailed: "Couldn't load people. Please try again.", signInSendVibes: 'Sign in to send vibe requests.', vibeRequestSendFailed: "Couldn't send vibe request. Please try again.",
    nowVibingWith: "You're now vibing with {name}!", leaveFailed: 'Could not leave chat. Please try again.', requestPassed: 'Request passed',
    gifSendFailed: 'Could not send GIF. Try again.', voiceUploadFailed: 'Voice note upload failed. Tap retry in the message.', reportSubmitted: 'Report submitted',
    now: 'now', minutesShort: '{count}m', hoursShort: '{count}h', daysShort: '{count}d',
    vibingCount_one: '{count} person vibing', vibingCount_few: '{count} people vibing', vibingCount_many: '{count} people vibing', vibingCount_other: '{count} people vibing',
    memberJoined: '{name} joined the chat', memberLeft: '{name} left the chat',
    lastSeenJustNow: 'Last seen just now',
    lastSeenMinutes_one: 'Last seen {count} min ago', lastSeenMinutes_few: 'Last seen {count} min ago', lastSeenMinutes_many: 'Last seen {count} min ago', lastSeenMinutes_other: 'Last seen {count} min ago',
    lastSeenHours_one: 'Last seen {count}h ago', lastSeenHours_few: 'Last seen {count}h ago', lastSeenHours_many: 'Last seen {count}h ago', lastSeenHours_other: 'Last seen {count}h ago',
    lastSeenYesterday: 'Last seen yesterday',
    lastSeenDays_one: 'Last seen {count}d ago', lastSeenDays_few: 'Last seen {count}d ago', lastSeenDays_many: 'Last seen {count}d ago', lastSeenDays_other: 'Last seen {count}d ago',
    lastSeenAWhileAgo: 'Last seen a while ago', seen: 'Seen', seenJustNow: 'Seen just now',
    seenMinutes_one: 'Seen {count} min ago', seenMinutes_few: 'Seen {count} min ago', seenMinutes_many: 'Seen {count} min ago', seenMinutes_other: 'Seen {count} min ago',
    seenHours_one: 'Seen {count}h ago', seenHours_few: 'Seen {count}h ago', seenHours_many: 'Seen {count}h ago', seenHours_other: 'Seen {count}h ago',
    yesterday: 'Yesterday', typing: 'Typing...', online: 'Online', studiZonePlan: 'StudiZone plan',
  },
  discover: {
    heroTitle: 'Vibes',
    vibesSubtitle: 'People. Places. Campus.',
    findMyVibeTitle: 'Find my vibe',
    findMyVibeDesc: 'Play the quiz. Meet your people.',
    venuesCardDesc: 'Partner profiles.',
    studiZoneCardDesc: 'Campus community.',
    statusOpensAt: 'Opens {time}',
    statusResultsAt: 'Results {time}',
    statusResultsOut: 'Results out',
    studiZoneVerifiedOnly: 'Verified students',
    infoPill: 'Answer a few questions. Get your vibe. Find your people.',
    addPhotoLocked: 'Add a real profile picture to vibe.',
    daySubtitle: 'Answer today’s vibe check',
    dayDescription: 'Answer a few daily questions to reveal your aura, then unlock your Vibe Circle and connect with people on your wavelength.',
    venueSubtitle: 'Discover who’s shaping your city',
    venueDescription: 'Explore local venues, artists, communities and hosts. Follow your favorites and discover their events, updates and calendars.',
    studiZoneTitle: 'StudiZone',
    studiZoneSubtitle: 'Your verified student space',
    studiZoneDescription: 'Find campus events, student plans, communities and chats made for verified students.',
    studiZoneButton: 'Enter StudiZone ->',
    letsGo: "Let's go ->",
    citySync: 'City sync',
    tonightSync: 'Tonight sync',
    auraLockedText: "New here? Don't worry.\nToday's aura scan opens at 6:00 AM.",
    auraQuestionsText: 'Answer the questions.\nFind your aura and unlock your Vibe Circle.',
    auraResultsText: 'Results out.\nFind your aura and who you vibe with today.',
    auraOpenTime: '6:00',
    auraResultsTime: '1:00',
    am: 'AM',
    pm: 'PM',
    live: 'LIVE',
    now: 'NOW',
    underConstruction: 'Under Construction',
    venueTesterUnavailable: 'Vibe at Venues is being prepared for early access. Aura Vibe remains available.',
  },
  feedFilters: {
    now: 'Now',
    tonight: 'Tonight',
    parties: 'Parties',
    social: 'Social',
    nearby: 'Nearby',
    'high-energy': 'High Energy',
    food: 'Food',
    activities: 'Activities',
    chill: 'Chill',
    'date-idea': 'Date Idea',
    'solo-friendly': 'Solo Friendly',
    student: 'Student',
    free: 'Free',
  },
  interests: {
    addInterests: 'Add Interests',
    selectedInterests: 'Selected Interests',
    selected: 'selected',
    searchInterests: 'Search interests',
    add: 'Add',
    saveInterests: 'Save Interests',
    categories: {
      travel: 'Travel',
      food_and_drinks: 'Food & Drinks',
      nightlife: 'Nightlife',
      sports_and_fitness: 'Sports & Fitness',
      music: 'Music',
      art_and_creativity: 'Art & Creativity',
      social_and_culture: 'Social & Culture',
      tech_and_gaming: 'Tech & Gaming',
      outdoors: 'Outdoors',
      relax_and_lifestyle: 'Relax & Lifestyle',
    },
    items: {
      backpacking: 'Backpacking', road_trips: 'Road Trips', solo_travel: 'Solo Travel',
      luxury_travel: 'Luxury Travel', digital_nomad: 'Digital Nomad', adventure_travel: 'Adventure Travel',
      city_exploration: 'City Exploration', beach_trips: 'Beach Trips', mountains: 'Mountains', camping: 'Camping',
      street_food: 'Street Food', fine_dining: 'Fine Dining', cafes: 'Cafes', bars: 'Bars',
      cocktails: 'Cocktails', wine_tasting: 'Wine Tasting', beer: 'Beer', cooking: 'Cooking',
      vegan_food: 'Vegan Food', desserts: 'Desserts', clubbing: 'Clubbing', house_music: 'House Music',
      techno: 'Techno', hip_hop: 'Hip Hop', live_djs: 'Live DJs', pub_crawls: 'Pub Crawls',
      after_parties: 'After Parties', festivals: 'Festivals', dance: 'Dance', karaoke: 'Karaoke',
      gym: 'Gym', running: 'Running', football: 'Football', basketball: 'Basketball', yoga: 'Yoga',
      hiking: 'Hiking', cycling: 'Cycling', swimming: 'Swimming', martial_arts: 'Martial Arts', crossfit: 'CrossFit',
      rap: 'Rap', pop: 'Pop', rock: 'Rock', edm: 'EDM', jazz: 'Jazz', classical: 'Classical',
      indie: 'Indie', lo_fi: 'Lo-fi', live_concerts: 'Live Concerts', singing: 'Singing',
      photography: 'Photography', painting: 'Painting', graphic_design: 'Graphic Design',
      illustration: 'Illustration', '3d_art': '3D Art', videography: 'Videography',
      content_creation: 'Content Creation', fashion: 'Fashion', tattoo_art: 'Tattoo Art', animation: 'Animation',
      meeting_people: 'Meeting People', languages: 'Languages', cultural_exchange: 'Cultural Exchange',
      volunteering: 'Volunteering', networking: 'Networking', events: 'Events',
      public_speaking: 'Public Speaking', debates: 'Debates', history: 'History', museums: 'Museums',
      gaming: 'Gaming', pc_gaming: 'PC Gaming', console_gaming: 'Console Gaming', ai: 'AI',
      startups: 'Startups', coding: 'Coding', cybersecurity: 'Cybersecurity', web3: 'Web3',
      gadgets: 'Gadgets', esports: 'Esports', nature: 'Nature', sunsets: 'Sunsets',
      photography_walks: 'Photography Walks', picnics: 'Picnics', fishing: 'Fishing', climbing: 'Climbing',
      kayaking: 'Kayaking', skiing: 'Skiing', snowboarding: 'Snowboarding', wildlife: 'Wildlife',
      netflix: 'Netflix', reading: 'Reading', meditation: 'Meditation', spa: 'Spa',
      journaling: 'Journaling', podcasts: 'Podcasts', shopping: 'Shopping', minimalism: 'Minimalism',
      self_growth: 'Self Growth', coffee: 'Coffee',
    },
  },
  feed: {
    free: 'Free',
    freeEntry: 'Free entry',
    paidEntry: 'Paid entry',
    ongoing: 'Ongoing',
    nowOn: 'Now on',
    runsUntil: 'Runs until',
    until: 'until',
    peopleGoing: 'people going',
    peopleGoingCount_one: '{count} person going',
    peopleGoingCount_few: '{count} people going',
    peopleGoingCount_many: '{count} people going',
    peopleGoingCount_other: '{count} people going',
    tonyteVenue: 'Tonyte venue',
    ticketsFrom: 'Tickets from',
    eyebrow: 'Official events and hosted happenings nearby',
    whatsOnIn: "What's On in",
    today: 'Today',
    tomorrow: 'Tomorrow',
    date: 'Date',
    gettingLocation: 'Getting your location...',
    locationDenied: 'Location access denied. Enable it in Settings to see nearby events.',
    enableLocation: 'Enable location to see nearby events.',
    featuredThisWeek: 'Featured This Week',
    topPicksForYou: 'Top Picks for You',
    popularNearYou: 'Popular Near You',
    topPicksError: 'Couldn\'t load your picks.',
    topPicksSubtitle: 'Events matched to your interests',
    topPicksSubtitlePopular: 'Trending events near you',
    topPicksSeeAll: 'See all',
    topPicksBadge: 'For You',
    topPicksEyebrow: 'Recommended for you',
    topPicksReason: {
      interest: 'Because you like {interest}',
      category: 'Matches your {category} interests',
      joined: 'Similar to events you’ve joined',
      shared: 'Similar to events you’ve shared',
      viewed: 'Based on events you’ve viewed'
    },
    allEvents: 'All Events',
    searchPlaceholder: 'Find your next vibe…',
    searchAccessibility: 'Search events, clubs or tags',
    searchResults: 'Search results',
    searchEmpty: 'No events match “{query}”',
    searchEmptySub: 'Try another name, club or tag.',
    loadingEvents: 'Loading events...',
    noEventsFound: 'No events found',
    noEventsSub: 'Check back soon or try a different filter.'
  },
  featuredAdmin: {
    title: 'Feature this event',
    thisWeek: 'This week',
    nextWeek: 'Next week',
    custom: 'Custom',
    startDate: 'Start date',
    endDate: 'End date',
    priority: 'Display priority',
    priorityHint: '1 shows first. Lower numbers appear before higher ones.',
    currentlyFeatured: 'This event is currently in Featured This Week.',
    save: 'Save',
    saveAnyway: 'Feature anyway',
    remove: 'Remove',
    checkingPartner: 'Checking partner account…',
    verifiedPartner: 'Posted by a verified Tonyte partner.',
    notPartner: 'This event wasn\'t posted by a verified partner account. Featuring is meant for partner events.',
    unknownPartner: 'Couldn\'t verify the partner account. Featuring is meant for partner events.',
    errors: {
      invalidDate: 'Enter dates as YYYY-MM-DD.',
      endBeforeStart: 'The end date must be after the start date.',
      alreadyEnded: 'That featured period has already ended.',
      invalidPriority: 'Priority must be a whole number from 1 to 999.',
      saveFailed: 'Could not save. Please try again.'
    }
  },
  map: {
    loadingMap: 'Loading map...',
    showEvents: 'Show events',
    hide: 'Hide',
    noMappedEvents: 'No mapped events nearby.',
    noMappedEventsNearby: 'No mapped events nearby',
    selectDate: 'Select date',
    selectCity: 'Select city',
    myLocation: 'My Location',
    locating: 'Locating…',
    locationDeniedTitle: 'Location Denied',
    locationDeniedMsg: 'Enable location access in Settings to use this feature.',
    locationUnavailableTitle: 'Location Unavailable',
    locationUnavailableMsg: 'Could not get your location. Please try again.',
    locationUnavailable: 'Location unavailable',
    locationPermissionDenied: 'Location permission denied',
    locationUnavailableHint: 'Turn on location services and try again.',
    locationPermissionDeniedHint: 'Allow location access in Settings to use your position.',
    recenterToMyLocation: 'Recenter to my location',
    invalidSharedLocation: "This location can't be shown right now.",
    dismissSharedLocation: 'Dismiss shared location',
  },
  categories: {
    social: 'Social',
    adventure: 'Adventure',
    culture: 'Culture',
    food: 'Food',
    nightlife: 'Nightlife',
  },
  event: {
    chatNoLongerAvailable: 'Chat no longer available',
    chatNoLongerAvailableBody: 'This chat no longer exists because the event is over.',
    registerOnLumaFirst: "Spots are limited — you'll register on Luma first, then we'll bring you back here.",
    couldNotOpenRegistration: "Could not open the registration page",
    plan: 'Plan',
    communityPlan: 'Community Plan',
    officialEvent: 'Official Event',
    clubEvent: 'Club Event',
    jamSession: 'Jam Session',
    tonight: 'Tonight',
    interested: 'interested',
    interestedCount_one: '{count} interested',
    interestedCount_few: '{count} interested',
    interestedCount_many: '{count} interested',
    interestedCount_other: '{count} interested',
    interestedBtn: 'Interested',
    members: 'members',
    memberCount_one: '{count} member',
    memberCount_few: '{count} members',
    memberCount_many: '{count} members',
    memberCount_other: '{count} members',
    eventChat: 'Event Chat',
    joiningChat: 'Joining…',
    openVenue: 'Open Venue',
    organizer: 'Organizer',
    leavePlan: 'Leave Plan',
    requestSentShort: 'Request sent',
    openChat: 'Open Chat',
    planChat: 'Plan Chat',
    dateTba: 'Date TBA',
    timeTba: 'Time TBA',
    decline: 'Decline',
    accept: 'Accept',
    tonyteNight: 'A Tonyte night worth showing up for.',
    lowRisk: 'Low risk',
    lowRiskSub: 'Public or clearly described plan',
    caution: 'Caution',
    cautionSub: 'Extra care recommended',
    highRisk: 'High risk',
    highRiskSub: 'Private or sensitive plan details',
    aboutThisPlan: 'About this plan',
    aboutThisEvent: 'About this event',
    detailsFinalized: 'Details are being finalized.',
    lineup: 'Lineup',
    genres: 'Genres',
    signInToJoinChats: 'Sign in to join event chats.',
    signInToMarkInterested: 'Sign in to mark events as interested.',
    signInToJoinPlans: 'Sign in to join plans.',
    chatUnavailable: 'Chat unavailable',
    noEventChat: 'This event does not include an event chat.',
    couldNotJoinChat: 'Could not join chat',
    removedFromPlan: 'You were removed from this plan.',
    requestSent: 'Request sent!',
    organizerWillReview: 'The organizer will review your request.',
    couldNotSendRequest: 'Could not send request',
    leftPlan: 'Left plan',
    couldNotLeavePlan: 'Could not leave plan',
    planDeleted: 'Plan deleted',
    couldNotDeletePlan: 'Could not delete plan',
    couldNotDeleteEvent: 'Could not delete event',
    noDateAvailable: 'No date available',
    noScheduledTime: 'This event does not have a scheduled time yet.',
    openingGoogleCalendar: 'Opening Google Calendar...',
    confirmCalendarSave: 'Confirm there to save the event.',
    deleteEventQuestion: 'Delete event?',
    deleteEventConfirm: 'Are you sure you want to delete this event? This action cannot be undone.',
    joinEventChatQuestion: 'Join event chat?',
    joinEventChatPrompt: 'Want to mark interested and join the event chat?',
    interestedOnly: 'Interested only',
    joinChat: 'Join Chat',
    shareEvent: 'Share Event',
    shareOutsideTonyte: 'Share outside Tonyte',
    sendInTonyteChat: 'Send in Tonyte Chat',
    shareIntro: 'Join this event on Tonyte 🎉',
    foundOnTonyte: 'Found this on Tonyte.',
    couldNotShare: 'Could not share',
    missingShareableId: 'This event is missing a shareable ID.',
    nativeShareUnavailable: 'The native share sheet is unavailable right now.',
    missingExternalLink: 'This event does not include a link yet.',
    couldNotUpdateInterest: 'Could not update interest',
    openGoogleMaps: 'Open in Google Maps',
    openMaps: 'Open in Maps',
    couldNotOpenMaps: 'Could not open maps',
    couldNotOpenEventLink: 'Could not open event link',
    viewOfficialEvent: 'View official event',
    capacity: 'Capacity',
    dateTime: 'Date & Time',
    calendar: 'Calendar',
    addToCalendar: 'Add to Calendar', publishedBy: 'Published by',
    eventsCount_one: '{count} event', eventsCount_few: '{count} events', eventsCount_many: '{count} events', eventsCount_other: '{count} events',
    joinedCount_one: '{count} joined', joinedCount_few: '{count} joined', joinedCount_many: '{count} joined', joinedCount_other: '{count} joined',
    venuePost: 'Venue post', hostedBy: 'Hosted by', addComment: 'Add a comment...', comments: 'Comments', tonyteUser: 'Tonyte user',
    openGoogleCalendar: 'Open Google Calendar',
    couldNotOpenCalendar: 'Could not open calendar',
    location: 'Location',
    exactLocationAfterApproval: 'Exact location shared in plan chat after approval.',
    joinRequests: 'Join Requests',
    couldNotAccept: 'Could not accept',
    couldNotDecline: 'Could not decline',
    requestToJoin: 'Request to join?',
    highRiskWarning: 'This plan may be in a private or sensitive setting. Please exercise extra caution.',
    mediumRiskWarning: 'This plan may involve alcohol or nightlife. Be mindful of your surroundings.',
    ackRisks: 'I understand the risks and want to proceed',
    messageOrganizerOptional: 'Add a message to the organizer (optional)',
    sendRequest: 'Send Request',
    deleteEventConfirmShort: 'Are you sure? This action cannot be undone.',
    requestToJoinFirst: 'Request to join first',
    requestToJoinFirstMsg: 'Send a join request to access the plan chat once accepted.',
    cancelRequestQuestion: 'Cancel request?',
    cancelRequestMsg: 'Withdraw your join request for this plan?',
    keepRequest: 'Keep request',
    cancelRequest: 'Cancel request',
    couldNotCancel: 'Could not cancel',
    adminCannotLeave: 'Plan admins cannot leave plans.',
    deletePlanInstead: 'Delete this plan instead?',
    deletePlanQuestion: 'Delete plan?',
    noStay: 'No, stay',
    yesDeletePlan: 'Yes, delete plan',
  },
  plans: {
    myPlans: 'My Plans',
    communityPlans: 'Community Plans',
    communityPlansSubtitle: 'Join group adventures near you',
    communityPlanBadge: 'COMMUNITY PLAN',
    freeBadge: 'FREE',
    postedBy: 'Posted by',
    member: 'member',
    open: 'Open',
    leave: 'Leave',
    request: 'Request',
    loading: 'Loading plans...',
    noneYet: 'No community plans yet',
    noneYetSubtitle: 'Create a plan to meet new people and explore together.',
    createPlan: 'Create Plan',
    completeProfile: 'Complete your profile to view plans',
    addRealProfilePicture: 'Add a real profile picture',
    completeProfileSubtitle: 'A real profile picture is required before you can join or create community plans.',
    signInTitle: 'Sign in to see Plans',
    signInSubtitle: 'Create an account to join and organize group adventures.',
    signInRequiredSubtitle: 'You need to sign in to join plans.',
    leaveFailed: 'Failed to leave the plan. Please try again.',
    planDeleted: 'Plan deleted',
    removed: 'has been removed.',
    deleteFailed: 'Could not delete the plan. Please try again.',
    requestSent: 'Request sent!',
    requestSentSubtitle: 'The plan organizer will review your request.',
    requestFailed: 'Could not send your request. Please try again.',
    deletePlan: 'Delete plan',
    deletePlanConfirmPrefix: 'Remove',
    deletePlanConfirmSuffix: 'permanently? This cannot be undone.',
    templatesTitle: 'Need an idea?',
    templatesSubtitle: 'Pick a plan and make it yours.',
  },
  share: {
    sentToChats: 'Sent to {count} chat',
    sentToChatsCount_one: 'Sent to {count} chat',
    sentToChatsCount_few: 'Sent to {count} chats',
    sentToChatsCount_many: 'Sent to {count} chats',
    sentToChatsCount_other: 'Sent to {count} chats',
    couldNotSend: 'Could not send. Please try again.',
  },
  forms: {
    searchAddressOrVenue: 'Search address or venue...',
  },
  completeProfile: {
    couldNotSave: 'Could not save. Try again.',
    couldNotUploadCover: 'Could not upload cover photo.',
    couldNotUploadProfilePhoto: 'Could not upload profile photo.',
    doneTitle: 'Profile Enhanced!',
    complete: 'Complete',
    doneSub: 'Your profile is now more discoverable. Better recommendations, smarter matches and more relevant events coming your way.',
    backToProfile: 'Back to Profile',
    profileBoost: 'PROFILE BOOST',
    enhanceExperience: 'Enhance your experience',
    addProfilePicture: 'Add a profile picture',
    addProfilePictureSub: 'A real photo helps people recognize you in vibes, chats and plans.',
    uploadPhoto: 'Upload Photo',
    keepCurrent: 'Keep Current',
    skipStep: 'Skip this step',
    dobTitle: 'Your date of birth',
    dobSub: 'This can only be set once and keeps Tonyte age-appropriate.',
    dobPlaceholder: 'Select day, month, year',
    chooseDob: 'Choose your date of birth to continue.',
    underMinAge: 'Tonyte is for travelers aged 16 and above.',
    saveContinue: 'Save & Continue',
    interestsTitle: 'What are you into?',
    interestsSub: 'Pick at least 3 so Tonyte can tune your recommendations.',
    selected: 'selected',
    pickInterests: 'Pick at least 3 interests.',
    locationTitle: 'Where are you based?',
    locationSub: 'Your base city helps Tonyte keep people and plans relevant.',
    city: 'City',
    country: 'Country',
    addBaseCity: 'Add your base city to continue.',
    bioTitle: 'Tell your story',
    bioSub: "A short bio helps people know who they're meeting.",
    bioPlaceholder: "Write something about yourself - what you're into, what you love, what gets you out...",
    coverTitle: 'Add a cover photo',
    coverSub: 'A great cover makes your profile stand out in Discover.',
    tapChooseCover: 'Tap to choose cover',
    uploadCover: 'Upload Cover',
    vibeTitle: "What's your vibe?",
    vibeSub: 'Your travel personality helps us recommend the right events and people.',
    musicTitle: 'Your music taste',
    musicSub: "We'll find events matching the music you love. Pick up to 5.",
    languagesTitle: 'Languages you speak',
    languagesSub: 'Find travelers you can actually talk to. Pick all that apply.',
    goingOutTitle: 'Going-out style',
    goingOutSub: 'What kind of nights do you enjoy? Choose all that apply.',
    saveFinish: 'Save & Finish',
    saveExit: 'Save & exit',
    socialVibeButterfly: 'Social Butterfly', socialVibeButterflyDesc: 'You thrive meeting new people.',
    socialVibeAdventurer: 'Adventurer', socialVibeAdventurerDesc: 'You seek thrills and new places.',
    socialVibeFoodie: 'Foodie', socialVibeFoodieDesc: 'Food is your love language.',
    socialVibeNightlife: 'Nightlife Lover', socialVibeNightlifeDesc: 'Best hours are after midnight.',
    socialVibeCulture: 'Culture Hunter', socialVibeCultureDesc: 'Museums, art, history — all of it.',
    socialVibeChill: 'Chill & Relaxed', socialVibeChillDesc: 'Slow travel, good vibes.',
    music_techno: 'Techno', music_house: 'House', music_hipHop: 'Hip Hop', music_rAndB: 'R&B', music_pop: 'Pop',
    music_rock: 'Rock', music_indie: 'Indie', music_edm: 'EDM', music_jazz: 'Jazz', music_classical: 'Classical',
    music_reggaeton: 'Reggaeton', music_afrobeats: 'Afrobeats', music_loFi: 'Lo-fi', music_drumBass: 'Drum & Bass', music_ambient: 'Ambient',
    spoken_english: 'English', spoken_german: 'German', spoken_french: 'French', spoken_spanish: 'Spanish', spoken_italian: 'Italian',
    spoken_portuguese: 'Portuguese', spoken_dutch: 'Dutch', spoken_polish: 'Polish', spoken_czech: 'Czech', spoken_romanian: 'Romanian',
    spoken_greek: 'Greek', spoken_hungarian: 'Hungarian', spoken_swedish: 'Swedish', spoken_danish: 'Danish', spoken_finnish: 'Finnish',
    spoken_hindi: 'Hindi', spoken_ukrainian: 'Ukrainian', spoken_russian: 'Russian', spoken_arabic: 'Arabic', spoken_chinese: 'Chinese', spoken_japanese: 'Japanese',
    goingOutClubs: 'Clubs & Parties', goingOutBars: 'Bars & Pubs', goingOutRooftops: 'Rooftops & Terraces',
    goingOutLiveMusic: 'Live Music', goingOutChill: 'Chill Spots', goingOutStreetFood: 'Street Food & Markets',
  },
  profile: {
    myVenueProfile: 'My Partner Profile', myVenueProfileSub: 'See your venue as visitors do',
    basedIn: 'Based in',
    locationNotAdded: 'Location not added',
    addBio: 'Add something about yourself',
    recently: 'Recently',
    events: 'Events',
    plans: 'Plans',
    interests: 'Interests',
    attended: 'Attended',
    created: 'Created',
    saved: 'Saved',
    memberSince: 'Member Since',
    exploringSince: 'With Tonyte since then.',
    tapToChangeCity: 'Change feed & map city',
    viewAll: 'View all',
    addInterest: 'Add Interest',
    uploadEvent: 'Upload Event',
    signOut: 'Sign Out',
    signOutConfirm: 'Are you sure you want to sign out?',
    cancel: 'Cancel',
    createAccountOrSignIn: 'Create Account or Sign In',
    logOut: 'Log Out',
    personality: 'Personality',
    editProfile: 'Edit Profile',
    shareProfile: 'Share Profile',
    qrCode: 'QR Code',
    verifications: 'Verifications',
    vibeVerified: 'Vibe Verified',
    studentVerified: 'Student Verified',
    earlyMember: 'Early Member',
    topPlanner: 'Top Planner',
    eventHost: 'Event Host',
    aura: 'Aura',
    myPlans: 'My Plans',
    loadingPlans: 'Loading plans...',
    upcomingPlansEmpty: 'Your upcoming plans will appear here.',
    createPlan: 'Create Plan',
    upcomingEvents: 'Upcoming Events',
    loadingEvents: 'Loading events...',
    upcomingEventsEmpty: 'No upcoming events yet.',
    interestedEvents: 'Interested Events',
    loadingInterestedEvents: 'Loading interested events...',
    interestedEventsEmpty: 'Events you mark interested will appear here.',
    browseEvents: 'Browse Events',
    badgesAchievements: 'Badges & Achievements',
    savedTemplates: 'Saved Templates',
    reusableEventDrafts: 'Reusable event drafts',
    uploadedPlans: 'Uploaded Plans',
    yourCreatedPlans: 'Your created plans',
    planRequests: 'Plan Requests',
    pendingPlanRequests: 'Pending join requests for your plans',
    todaysVibe: "Today's Vibe",
    todaysVibePrompt: 'Discover your vibe',
    todaysVibePromptSub: 'Answer a few quick questions',
    loadingVibeMatches: 'Loading vibe matches...',
    vibeMatchWaiting: 'vibe match waiting',
    vibeMatchesWaiting: 'vibe matches waiting',
    vibeMatchWaitingCount_one: '{count} vibe match waiting',
    vibeMatchWaitingCount_few: '{count} vibe matches waiting',
    vibeMatchWaitingCount_many: '{count} vibe matches waiting',
    vibeMatchWaitingCount_other: '{count} vibe matches waiting',
    following: 'Following',
    followingSearch: 'Search partners you follow',
    followingEmpty: 'You\u2019re not following any partners yet. Find them in Vibe at Venues.',
    followingNoMatch: 'No partners match your search.',
    followingCount_one: '{count} partner',
    followingCount_few: '{count} partners',
    followingCount_many: '{count} partners',
    followingCount_other: '{count} partners',
    studiZoneOpen: 'Open',
    studiZonePending: 'Pending',
    studiZoneVerify: 'Verify to unlock',
    updateRole: 'Update user role?', changeRole: "Change {name}'s role from {from} to {to}?", updateRoleAction: 'Update Role',
    noRolePermission: 'You do not have permission to update this role.', coAdminRoleRestriction: 'Co-admins cannot assign or modify admin/co-admin accounts.', adminSignInRequired: 'You must be signed in as an admin to update roles.', roleUpdateFailed: 'Unable to update role right now.', roleUpdated: 'User role updated.',
    uploadingProfile: 'Uploading profile photo…', uploadingCover: 'Uploading cover photo…', profileSaved: 'Profile photo saved.', coverSaved: 'Cover photo saved.', imageUpdateFailed: 'Could not update image', removeProfilePhoto: 'Remove profile photo?', removeCoverPhoto: 'Remove cover photo?', restoreDefault: 'This will restore the default image.', remove: 'Remove', imageRemoveFailed: 'Could not remove image', interestsSaveFailed: 'Could not save interests', notificationsSaveFailed: 'Could not save notifications',
    reviewFailed: 'Could not review request', unchanged: 'Please try again — nothing was changed.', revokeFailed: 'Could not revoke badge', revokeSuccessTitle: 'Vibe Verified revoked', revokeSuccessBody: 'This user\'s Vibe Verified badge has been removed.', shareFailed: 'Could not share', missingShareId: 'This profile is missing a shareable ID.', shareUnavailable: 'The native share sheet is unavailable right now.', qrUnavailable: 'QR unavailable',
    vibesHub: 'Vibes', vibesHubSub: 'Your personal chat and vibe connections', admin: 'Admin', userManagement: 'User Management', usersCount: '{count} users', adminHelp: 'Manage Tonyte roles for users, testers, organizers, venues, co-admins and admins.', userManagementSub: 'Search users and assign roles.', studentVerifications: 'Student Verifications', faceVerificationRequests: 'Face Verification Requests', pendingReviewCount: '{count} pending review', pendingReviewCount_one: '{count} pending review', pendingReviewCount_few: '{count} pending reviews', pendingReviewCount_many: '{count} pending reviews', pendingReviewCount_other: '{count} pending reviews', loading: 'Loading…',
    change: 'Change', close: 'Close', myQrCode: 'My QR Code', share: 'Share', coverPhoto: 'Cover Photo', viewCover: 'View Cover', changeCover: 'Change Cover', removeCover: 'Remove Cover',
    tonyteTraveler: 'Tonyte Traveler', blockedAccountsLoadFailed: 'Could not load blocked accounts right now.', unblockFailed: 'Could not unblock this account right now.',
    noConnectedEmail: 'No email is connected to this account.', passwordResetSent: 'Password reset link sent to {email}.', passwordResetFailed: 'Could not send reset email right now.',
    enterValidStudentEmail: 'Enter a valid student email address.', studentVerificationEmailSent: 'Verification email sent! Check your university inbox and click the link to confirm.', studentVerificationEmailFailed: 'Could not send verification email. Please try again.',
    feedbackMessageRequired: 'Please enter a feedback message.', feedbackTypeRequired: 'Please choose a feedback type.', feedbackThanks: 'Thanks, feedback sent.', feedbackSaveFailed: 'Could not save feedback. Please try again.',
    feedbackType_general: 'General', feedbackType_bug: 'Bug', feedbackType_feature: 'Feature request', feedbackType_event_issue: 'Event issue',
    noSignedInUser: 'No signed-in user found.', missingEmailForConfirmation: 'Your account is missing an email address for password confirmation.', enterPasswordToContinue: 'Please enter your password to continue.',
    googleReauthUnavailable: 'Google reauthentication is not available in this build.', googleMissingIdToken: 'Google reauthentication did not return an ID token.', appleReauthUnavailable: 'Apple reauthentication is not available on this device.', appleMissingIdentityToken: 'Apple reauthentication did not return an identity token.',
    deleteRequiresRecentLogin: 'Please sign in again to confirm account deletion.', deleteInvalidCredential: 'That password or sign-in credential was not accepted. Please try again.', deleteUserMismatch: 'Please reauthenticate with the same account currently signed into Tonyte.', deleteReauthInterrupted: 'Reauthentication was interrupted. Please try again.', deleteNetworkError: 'Network error. Check your connection and try again.', deletePermissionDenied: 'Permission denied. Please sign in again and try once more.', deleteFailedAtStage: 'Delete account failed at {stage}: {error}', deleteUnavailable: 'Could not delete your account right now.', signInAgainBeforeDelete: 'Please sign in again before deleting your account.', mustSignInToDelete: 'You need to be signed in to delete your account.', accountCleanupFailed: 'Account cleanup HTTP request failed.',
    selfieUnclear: 'Selfie is too small or unclear. Please retake it in good light with your face and gesture visible.', selfieRequired: 'Take your verification selfie before submitting.', verificationSyncPending: 'Verification submitted. Status sync pending.', verificationReviewFailed: 'Verification review failed.', vibeVerifiedApproved: 'Approved Vibe Verified for {user}.', verificationClearSelfieFailed: 'Verification failed. Please try again with a clear selfie.', revokeNotConfirmed: 'Revoke did not confirm success.',
    shareTitle: 'Tonyte Profile', shareMessage: 'Check out my Tonyte profile:\n{url}', acceptSaveDomain: 'Accept + Save Domain', tonyteUser: 'Tonyte User',
    verificationEmailSentTitle: 'Verification Email Sent', verificationPendingTitle: 'Verification Pending', verificationFailedTitle: 'Verification Failed', studentVerificationTitle: 'Student Verification', verificationCheckInboxBody: 'Please check your inbox and confirm that this email belongs to you.', verificationReviewingBody: "We're reviewing your student status.", verificationFailedBody: "We couldn't verify your student status. Please check your student email or try again.", verificationUnlockBody: 'Unlock student events, Erasmus meetups, campus nightlife, student-only events, plans and chats.', studiZoneUnderConstruction: 'StudiZone under construction', enterStudiZone: 'Enter StudiZone', verifyStudentStatus: 'Verify Student Status',
    faq1Question: 'What is Tonyte?', faq1Answer: 'Tonyte helps you discover events, join plans, and meet people nearby while traveling or living in a city.',
    faq2Question: 'Is Tonyte free?', faq2Answer: 'Yes, core features like discovering events, joining plans, and chatting are free.',
    faq3Question: 'Who can see my profile?', faq3Answer: 'Users can see your profile when you interact with them through chats, plans, events, or shared profile links.',
    faq4Question: 'What is a plan?', faq4Answer: 'A plan is a casual meetup created by a user, such as coffee, BBQ, sightseeing, games, or going out.',
    faq5Question: 'Who can create plans?', faq5Answer: 'Any signed-in user can create a community plan.',
    faq6Question: 'What happens when I join a plan?', faq6Answer: "You may be added to the plan's attendee list and get access to the plan chat.",
    faq7Question: 'Can I leave a plan?', faq7Answer: 'Yes, normal participants can leave a plan. Organizers cannot leave their own plan unless they delete it.',
    faq8Question: 'Can an organizer remove me from a plan?', faq8Answer: 'Yes. Organizers can remove people from their own plans to manage safety and comfort.',
    faq9Question: 'What happens if I am removed from a plan?', faq9Answer: 'You cannot rejoin that plan, but you can still view the chat and report the plan or specific users if needed.',
    faq10Question: 'Who can message me?', faq10Answer: 'People can message you through matches, event chats, or plan chats.',
    faq11Question: "Why can't I send messages in a chat?", faq11Answer: 'You may no longer be an active participant, or you may have been removed from that plan/chat.',
    faq12Question: 'Can I report someone?', faq12Answer: 'Yes. You can report users, plans, events, or chat behavior if something feels unsafe, abusive, discriminatory, or inappropriate.',
    faq13Question: 'Is my exact location visible?', faq13Answer: 'No. Location is used to show nearby events and plans. Your exact live location is not shown to other users.',
    faq14Question: 'Can I edit my profile?', faq14Answer: 'Yes. You can update your name, city, bio, photos, and interests anytime.',
    faq15Question: 'How do I delete my account?', faq15Answer: 'Go to Profile Settings → Delete Account.',
    faq16Question: 'The app is not working properly. What should I do?', faq16Answer: 'Use Help & Feedback inside Settings and describe the issue.',
  },
  vibes: {
    synchronize: 'Synchronize',
    lockInToday: "Lock in today's vibe",
    getYourVibesSynchronized: 'Get Your Vibes\nSynchronized',
    getYourVibesSynchronizedFlat: 'Get your vibes synchronized',
    vibeCircle: 'Vibe Circle',
    vibeAlignment: 'Vibe Alignment',
    sharedFrequency: 'Shared Frequency',
    instantSync: 'Instant Sync',
    strongSync: 'Strong Sync',
    recommendedVibe: 'Recommended Vibe',
    openChat: 'Open chat',
    continueChat: 'Continue chat',
    sendVibe: 'Send vibe',
    startSync: 'Start sync',
    pickAllHint: 'Pick all that fit your vibe right now.',
    dontOverthink: "Don't overthink it.",
    pickUpTo: 'Pick up to',
    couldNotSaveVibe: 'Could not save',
    couldNotSaveVibeSub: "Couldn't save your vibe yet. Please try again.",
    icebreakersReady: 'Two icebreaker questions are ready in your chat.',
    suggestedIcebreaker: 'Suggested icebreaker',
    signalLocked: 'signal locked',
    signalsLocked: 'signals locked',
    signalLockedCount_one: '{count} signal locked',
    signalLockedCount_few: '{count} signals locked',
    signalLockedCount_many: '{count} signals locked',
    signalLockedCount_other: '{count} signals locked',
    chooseOneSignal: 'Choose one signal',
    chooseUpTo: 'Choose up to',
    next: 'Next',
    microcopy0: "Don't overthink it.",
    microcopy1: "Go with today's energy.",
    microcopy2: 'This can change tomorrow.',
    microcopy3: 'Current vibe only.',
    microcopy4: 'Be honest.',
    microcopy5: 'First instinct is usually right.',
    dayVibesBadge: 'DAY VIBES',
    questionOf: 'Question',
    resultsUnlock1pm: 'Results unlock at 1:00 PM',
    lastOne: 'Last one!',
    questionsLeft: 'questions left',
    questionLeft: 'question left',
    questionLeftCount_one: '{count} question left',
    questionLeftCount_few: '{count} questions left',
    questionLeftCount_many: '{count} questions left',
    questionLeftCount_other: '{count} questions left',
    openAt6am: "Today's aura scan opens at 6:00 AM.",
    resetDaily: 'Fresh questions and Vibe Circle results reset with the new day.',
    loadingAura: "Loading today's aura...",
    noAuraToday: 'No aura found for today.',
    goBack: 'Go back',
    todaysAura: "Today's Aura",
    todayYouAre: 'TODAY YOU ARE',
    resultsIn: 'Results in',
    basedOnToday: "Based on today's Day Vibes",
    findingWavelength: 'Finding people on your wavelength...',
    noAlignmentYet: 'No Vibe Alignment yet',
    noAlignmentSubtitle: "No one on your wavelength has finished today's game yet. New matches can arrive as others play — they'll appear here automatically.",
    firstVibesUnlock: "You're in! Your first vibes unlock at 13:00.",
    moreMatchesLater: "More matches can arrive as people join afterward — your Vibe Circle keeps updating all day.",
    matchingInProgress: "Finding your vibes…",
    matchingInProgressBody: "We're checking everyone who has played today. This updates by itself.",
    matchingRetryingBody: "This is taking a little longer than usual — we're still on it. Your vibes will appear here automatically.",
    moreCanArrive: "More vibes can arrive as people finish today's game.",
    resultsRightAway: "Results right after you finish",
    refresh: 'Refresh',
    sync: 'sync',
    sharedFrequencyToday: 'shared frequency today',
    sharedFrequenciesToday: 'shared frequencies today',
    alignmentPercentPrefix: 'Your vibe alignment is',
    icebreakerPrompt1: 'What would you both genuinely say yes to today?',
    icebreakerPrompt2: 'What setting would make your shared vibe feel effortless?',
    auraCitySoulName: 'City Soul',
    auraCitySoulDescription: "You're giving curious, cinematic and quietly adventurous energy today.",
    auraCitySoulTrait1: 'City Explorer',
    auraCitySoulTrait2: 'Soft Social',
    auraCitySoulTrait3: 'Aesthetic Mood',
    auraSoftChaosName: 'Soft Chaos',
    auraSoftChaosDescription: 'Spontaneous plans, social sparks, and beautifully unstructured energy.',
    auraSoftChaosTrait1: 'Spontaneous',
    auraSoftChaosTrait2: 'Café Hopper',
    auraSoftChaosTrait3: 'Social Today',
    auraGoldenHourName: 'Golden Hour',
    auraGoldenHourDescription: 'Warm, unhurried, and glowing with intentional presence today.',
    auraGoldenHourTrait1: 'Intentional',
    auraGoldenHourTrait2: 'Warmth Seeker',
    auraGoldenHourTrait3: 'Present Moment',
    auraNeonWolfName: 'Neon Wolf',
    auraNeonWolfDescription: 'Bold, charged, and running on electric independent energy today.',
    auraNeonWolfTrait1: 'Independent',
    auraNeonWolfTrait2: 'Electrically Bold',
    auraNeonWolfTrait3: 'Night-Ready',
    auraQuietStormName: 'Quiet Storm',
    auraQuietStormDescription: 'Deeply present, creatively alive, and quietly powerful today.',
    auraQuietStormTrait1: 'Introspective',
    auraQuietStormTrait2: 'Creatively Driven',
    auraQuietStormTrait3: 'Deeply Aware',
    auraSolarBurstName: 'Solar Burst',
    auraSolarBurstDescription: 'Radiant, magnetic, and overflowing with outward energy today.',
    auraSolarBurstTrait1: 'High Energy',
    auraSolarBurstTrait2: 'Radiantly Open',
    auraSolarBurstTrait3: 'Magnetically Social',
    reset: 'Reset',
    scan: 'Scan',
    auraBadgeAccessibility: '{name} aura badge',
    auraBadgeHint: "Expands today's aura description",
  },
  venues: {
    vibeAtVenues: 'Vibe at Venues',
  },
  imageCrop: {
    profilePhoto: 'Profile Photo',
    eventPhoto: 'Event Photo',
    coverPhoto: 'Cover Photo',
    frameProfile: 'Frame your profile photo',
    frameEvent: 'Frame your event photo',
    frameCover: 'Frame your cover photo',
    previewBeforeSaving: 'Preview the image before saving.',
    dragToReposition: 'Drag photo to reposition',
    fitEntireImage: 'Fit entire image',
    cropToFill: 'Crop to fill',
    completeImageHint: 'The complete image will be saved',
    viewFullImage: 'View full event image',
    zoom: 'Zoom',
    cropping: 'Cropping...',
    useImage: 'Use Image',
  },
  appUpdate: {
    defaultTitle: 'Tonyte just got better',
    defaultMessage: "We've improved maps, plans, profiles, and the overall app experience.",
    newVersion: 'New version available',
    newVersionNamed: 'New version {version} available',
    opening: 'Opening...',
    updateNow: 'Update now',
    optionalTitle: "Update Tonyte 🧡",
    optionalMessage: "A newer version is available with the latest features, fixes and improvements.",
    requiredTitle: "Tonyte needs an update",
    requiredMessage: "Please update Tonyte to continue using the app.",
    updateTonyte: "Update Tonyte",
    notNow: "Not now",
  },
  languages: {
    en: 'English',
    de: 'German',
    es: 'Spanish',
    fr: 'French',
    ru: 'Russian',
  },
  vibeClaim: {
    playedOnWeb: "Played the Vibe game on the web?",
    enterCodeTitle: "Add your web answers",
    enterCodeBody: "Enter the code from the end of the Vibe game on tonyte.app.",
    continue: "Continue",
    ok: "OK",
    invalidFormat: "Codes look like ABCD-EFGH.",
    invalidCode: "That code doesn't exist or has expired.",
    oldRoundCode: "That code was for an earlier round, which has closed.",
    alreadyClaimedCode: "Those answers were already added to a Tonyte account.",
    savedSignIn: "Got it! Sign in or create an account and we'll add your answers.",
    networkError: "Couldn't check the code. Check your connection and try again.",
    rateLimited: "Too many tries. Please wait a few minutes.",
    waitingBanner: "Your Vibe answers from the web are waiting. Sign in or sign up to see your vibes.",
    discard: "Discard web answers",
    addedToast: "Your web answers are in ✨",
    unlocksAt13: "Your first vibes unlock at 13:00.",
    alreadyPlayedTodayTitle: "You've played today's Vibe game",
    alreadyPlayedTodayBody: "Your answers for today are already in. Each account plays once per day, so a web code can't be added on top. A new round starts tomorrow at 6:00.",
    addingTitle: "Adding your web answers…",
    addingBody: "We're adding the answers from the code you entered. This only takes a moment.",
    notOpenTitle: "Today's game isn't open yet",
    notOpenBody: "The Vibe game opens at 6:00. Codes only work on the day you played.",
    seeMyVibes: "See my vibes",
    alreadyPlayedTitle: "You already played today",
    alreadyPlayedBody: "You'd already answered today's Vibe questions in the app, so we kept those. Answers lock once they're in, so your web answers weren't used.",
    roundClosedTitle: "Those answers were for {date}",
    roundClosedBody: "Web answers only count in the round they were played, and that round has closed. Today's questions are waiting in Day Vibes.",
    playToday: "Play today",
    claimedElsewhereTitle: "Already on another account",
    claimedElsewhereBody: "These answers were added to a different Tonyte account. Each set of answers can belong to only one account.",
    notFoundTitle: "Couldn't add those answers",
    notFoundBody: "The link or code has expired or isn't valid. Web answers can be added until midnight (Berlin time) on the day you played.",
    notEligibleBody: "Day Vibes isn't available for this account type.",
    emailFoundTitle: "Add your web answers?",
    emailFoundBody: "You saved today's Vibe answers on tonyte.app with {email}. Add them to this account?",
    addAnswers: "Add answers",
    notNow: "Not now",
  },
  partnerCommunity: {
    button: 'Community chat',
    followToJoinTitle: 'Follow to join?',
    followToJoinBody: 'Follow {name} to join their community chat.',
    followAndJoin: 'Follow & join',
    signIn: 'Sign in to join this partner’s community. You’ll return here afterward.',
    signInAction: 'Sign in',
    joinFailed: 'Couldn’t join the community. Please try again.',
    unfollowTitle: 'Unfollow and leave community?',
    unfollowBody: 'Unfollowing {name} also removes you from their community chat.',
    unfollowAndLeave: 'Unfollow & leave',
    messagesTab: 'Messages',
    notificationsTab: 'Notifications',
    communitiesTab: 'Community Chats',
    incoming: 'Incoming requests',
    outgoing: 'Outgoing requests',
    emptyTitle: 'Find your communities',
    emptyBody: 'Follow a partner and join their community to chat with people around it.',
    discover: 'Discover partners',
    about: 'The official member chat for this partner.',
    memberOnly: 'Followers’ community',
    leaveConfirm: 'Leave this community chat? You will keep following the partner.',
    ownerCannotLeave: 'You administer this community as the partner owner.',
    accessRemoved: 'You no longer have access to this community.',
    allowBack: 'Allow back',
    allowedBack: 'This person can rejoin after following the partner.',
    rejoined: 'Member reinstated.',
    descriptionPlaceholder: 'Add a community description…',
    descriptionSaved: 'Community description updated.',
    descriptionSaveFailed: 'Couldn’t update the description. Please try again.',
    admin: 'Admin',
    coAdmin: 'Co-admin',
    makeCoAdmin: 'Make co-admin',
    removeCoAdmin: 'Remove co-admin role',
    coAdminAdded: '{name} is now a co-admin.',
    coAdminRemoved: '{name} is no longer a co-admin.',
  },
  "partnerReviews": {
    "tab": "Reviews",
    "reviewCount_one": "{count} review",
    "reviewCount_other": "{count} reviews",
    "ratingCount_one": "{count} rating",
    "ratingCount_other": "{count} ratings",
    "starCount_one": "{count} star",
    "starCount_other": "{count} stars",
    "noReviewsYet": "No reviews yet",
    "beFirst": "Be the first",
    "summaryA11y": "Rated {avg} out of 5 from {count} reviews. Show reviews",
    "write": "Write a review",
    "edit": "Edit your review",
    "ownProfile": "Reviews come from visitors — you can’t review your own profile.",
    "signInToReview": "Log in or create an account to write a review.",
    "filterAll": "All",
    "empty": "No reviews yet",
    "emptySub": "Been here? Share how it was and help others decide.",
    "emptyFiltered": "No {count}-star reviews yet.",
    "loadFailed": "Couldn’t load reviews.",
    "retry": "Try again",
    "showMore": "Show more reviews",
    "edited": "Edited",
    "readMore": "Read more",
    "showLess": "Show less",
    "yourReview": "Your review",
    "hiddenNotice": "Only you can see this review while our team checks it.",
    "removedNotice": "Our moderators removed this review. You can delete it and write a new one.",
    "menu": "Review options",
    "titleNew": "Rate {name}",
    "titleEdit": "Edit your review",
    "aboutPartner": "You’re reviewing {name} overall, not a single event.",
    "draftRestored": "We kept your unfinished review.",
    "ratingLabel": "Your rating",
    "tapToRate": "Tap a star to rate",
    "ratingRequired": "Choose a star rating to continue.",
    "textLabel": "Your review (optional)",
    "placeholder": "What was it like? Atmosphere, people, events…",
    "submit": "Post review",
    "update": "Save changes",
    "posted": "Thanks for your review!",
    "updated": "Review updated",
    "deleted": "Review deleted",
    "deleteTitle": "Delete your review?",
    "deleteBody": "Your rating and text will be removed from {name}.",
    "ratingWords": {
      "1": "Not for me",
      "2": "Could be better",
      "3": "Okay",
      "4": "Really good",
      "5": "Loved it"
    },
    "actions": {
      "edit": "Edit review",
      "delete": "Delete review",
      "report": "Report review",
      "hide": "Hide review (admin)",
      "restore": "Restore review (admin)",
      "remove": "Remove review (admin)",
      "dismiss": "Dismiss reports"
    },
    "confirm": {
      "hideTitle": "Hide this review?",
      "hideBody": "It disappears from the profile and no longer counts towards the rating until it’s restored.",
      "removeTitle": "Remove this review?",
      "removeBody": "The text is erased and it no longer counts towards the rating. This can’t be undone.",
      "dismissTitle": "Dismiss these reports?",
      "dismissBody": "The review stays visible and the reports are closed."
    },
    "moderated": {
      "hide": "Review hidden",
      "restore": "Review restored",
      "remove": "Review removed",
      "dismiss": "Reports dismissed"
    },
    "reportTitle": "Report this review",
    "reportReason": "Why are you reporting it?",
    "reasons": {
      "spam": "Spam or advertising",
      "harassment": "Harassment or hate",
      "inappropriate": "Inappropriate content",
      "fake": "Fake or misleading",
      "other": "Something else"
    },
    "reportDetails": "Anything else we should know? (optional)",
    "reportSubmit": "Send report",
    "reported": "Thanks — our team will take a look.",
    "errors": {
      "signIn": "Please log in again to post your review. Your draft is saved.",
      "verifyEmail": "Verify your email to post reviews. Your draft is saved.",
      "ownProfile": "You can’t review your own profile.",
      "removed": "This review was removed by moderators and can’t be edited.",
      "rating": "Choose a rating from 1 to 5 stars.",
      "tooLong": "Reviews can be at most 1,000 characters.",
      "unavailable": "This profile isn’t available.",
      "reviewGone": "This review is no longer available.",
      "ownReview": "You can’t report your own review.",
      "access": "Your account can’t post reviews right now.",
      "network": "Connection problem — please try again. Your draft is saved.",
      "generic": "Something went wrong. Please try again."
    },
    "admin": {
      "title": "Reported reviews",
      "profileSub": "Hide or remove reported partner reviews",
      "open": "Open",
      "resolved": "Resolved",
      "empty": "No reported reviews.",
      "reason": "Reason",
      "details": "Details",
      "reportedAt": "Reported {date}",
      "currentStatus": "Now",
      "status": {
        "published": "Visible",
        "hidden": "Hidden",
        "removed": "Removed",
        "missing": "Deleted"
      },
      "resolution": {
        "hidden": "Hidden",
        "removed": "Removed",
        "dismissed": "Dismissed",
        "review_deleted": "Deleted by author",
        "restored": "Restored"
      },
      "openProfile": "Open profile",
      "loadFailed": "Couldn’t load reports."
    }
  }
};
